<template>
    <!-- <div v-if="isLoaded"> -->
    <div>    
        <div class="modal" tabindex="-1" role="dialog" id="remote_edit_window">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header p-2" style="display:inline-flex;width:100%;align-items:center">
                        <h4 class="review-title-heading" style="float:inline-start;margin-bottom:0px;" :title="fileInfo.slug_name?fileInfo.slug_name:fileInfo.file_name">{{$t('Face Detection')}} - <span>{{fileInfo.slug_name?fileInfo.slug_name:fileInfo.file_name }}</span></h4>  
                        <div style="display: flex; align-items: center; justify-content: flex-end; gap: 10px;"
                            :style="(fileInfo.mime_type && fileInfo.mime_type.startsWith('video/'))?'width: 100%':'width: 69%'">
                            <div style="width: 350px;">
                                <Multiselect
                                    v-model="selectedServiceDetails"
                                    :options="serviceOptionList"
                                    label="name"
                                    :placeholder="$t('Select Service')"
                                    :hideSelected="false"
                                    :close-on-select="true"
                                    deselectLabel=""
                                    selectLabel=""
                                    selectedLabel=""
                                    :showNoOptions="false"
                                    ref="serviceDropdownRef"
                                    @select="saveService($event)"
                                    class="service-dropdown"
                                    >
                                    <span slot="noResult">No results.</span>
                                </Multiselect>
                            </div>
                            <div style="display: flex;align-items: center;float:inline-end;gap:10px;">
                               <button v-if="isImageFile()" class="btn  button-styles manual-draw-box" :class="isCustomFaceboxEnabled ? 'btn-outline-primary': 'btn-outline-secondary' " @click="enableDisableManualFaceboxSelection()" style="padding: 5px 10px; line-height: 2px; height: 36px;">
                                   <svg xmlns="http://www.w3.org/2000/svg" style="height: 23px;color:#cbcbcb" height="23px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0z" fill="none"/><path d="M17 5h-2V3h2v2zm-2 16h2v-2.59L19.59 21 21 19.59 18.41 17H21v-2h-6v6zm4-12h2V7h-2v2zm0 4h2v-2h-2v2zm-8 8h2v-2h-2v2zM7 5h2V3H7v2zM3 17h2v-2H3v2zm2 4v-2H3c0 1.1.9 2 2 2zM19 3v2h2c0-1.1-.9-2-2-2zm-8 2h2V3h-2v2zM3 9h2V7H3v2zm4 12h2v-2H7v2zm-4-8h2v-2H3v2zm0-8h2V3c-1.1 0-2 .9-2 2z"/>
                                    <title>{{$t('Manual Face selection')}}</title>
                                   </svg>
                                </button>
                                <button v-if="fileInfo.mime_type && fileInfo.mime_type.startsWith('video/')" class="btn btn-outline-primary button-styles" @click="captureFrame()" style="padding: 5px 10px; line-height: 2px; height: 36px;border-color: #1d868c;background: #1d868c;color:#eee">
                                    <template v-if="faceDetectContext && faceDetectContext == 'fromPersonalityContext'">Extract Frame</template>
                                     <template v-else>{{$t('Detect in Frame')}}</template>
                                </button>
                                <template v-if="!faceDetectContext || (faceDetectContext && fileInfo.mime_type.startsWith('image/'))">
                                    <button  class="btn btn-outline-primary button-styles" @click="createFaceDetectionJob()"
                                     style="padding: 5px 10px; line-height: 2px;margin-inline-end:8px; height: 36px;border-color: #1d868c;background: #1d868c;color:#eee"
                                     v-if="visionConfig.enable_fd_for_video && fileInfo.mime_type && fileInfo.mime_type.startsWith('video/')">
                                     {{$t('Detect in Video')}}
                                    </button>
                                    <button class="btn btn-outline-primary button-styles" @click="createFaceDetectionJob()"
                                     style="width:120px;padding: 5px 10px; line-height: 2px; height: 36px;margin-inline-end:8px;border-color: #1d868c;background: #1d868c;color:#eee"
                                     v-if="fileInfo.mime_type && fileInfo.mime_type.startsWith('image/')">
                                     {{$t('Detect Faces')}}
                                    </button>
                                </template>
                                <div style="float:inline-end; width: 42px;height: 40px;display: inline-flex;align-items: center;justify-content: center;">
                                    <svg @click="closeModel()" width="3em" height="3em" viewBox="0 0 16 16" class="bi bi-x" fill="#939393" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>    
                    <div class="modal-body">
                        <div class="w-100 face-detection-main-wrapper" style="height:100%;display:flex;justify-content:center">
                            <div class="priview-panel" ref="mainPreviewPanel">
                                <!-- <div style="position: absolute; display: inline-flex; justify-content: center;width: 100%;">
                                    <span style="background: #0000008c;padding:5px 10px">{{fileInfo.slug_name?fileInfo.slug_name:fileInfo.file_name }}</span>
                                </div> -->
                                <div class="preview-child-wrapper" ref="previewChildPanel" :style="isVideoFile()?'height: calc(100% - 70px)':'height: 100%'" style="display: inline-flex; width: 100%;justify-content: center;align-items:center">
                                    <template v-if="isVideoFile()">
                                        <div style="height:100%;width:100%;display:inline-block">
                                            <video-player ref="videoPlayerRef" id="video-player-id" @controller="setController" :isCurrentTimeUpdateRequired="true" :isProgressbarRequired="true" :options="videoOptions" @metaDataLoaded="videoPlaytoggle" :src="getLowresPath(fileInfo)" style="height:100%;width:100%"/>
                                        </div>
                                    </template>
                                    <!-- <embed v-if="!isVideoFile" src="http://www.pdf995.com/samples/pdf.pdf" alt="pdf" style="height:100%;width:100%" pluginspage="http://www.adobe.com/products/acrobat/readstep2.html"> -->
                                    <div v-if="isImageFile() && !isImageLoadedForFaceDetection" style="align-items: center;justify-content: center;height: 100%;width:100px;display: inline-flex;">
                                        <img :src="loadingImageForFateDetect" @load="imagesLoadedCallback" style="disaply:inline-block;width:100%">
                                    </div>
                                    <img v-else-if="isImageFile()&& isImageLoadedForFaceDetection" id="face-detection-image" :src="getProxyConvertedURL(loadedImagePath)" @error="replaceByDefaultImage" @load="imagesLoadedCallback" style="display:inline-block">
                                    <!-- <img v-if="isImageFile()" :src="getThumbnailPath(fileInfo)" @error="replaceByDefaultImage" @load="imagesLoadedCallback" style="width:auto;height:auto;margin:auto"> -->
                                    <template v-for="faceObj in filteredObjects">
                                        <div v-if="fileInfo.mime_type.startsWith('image') && (!faceObj.manually_deleted) && isImageLoadedForFaceDetection" @click="showPersonalityDropdown(faceObj)" :ref="'face_'+faceObj.uuid" :key="faceObj.uuid" class="comm-object-boxes" style="position:absolute"
                                            :style="{
                                                'width':(((faceObj.coordinates[2]) - (faceObj.coordinates[0]))/onePxWidthValue) +'px',
                                                'height':(((faceObj.coordinates[3]) - (faceObj.coordinates[1]))/onePxHeightValue) +'px',
                                                'top':((faceObj.coordinates[1])/onePxHeightValue) + imageActualTop +'px',
                                                'left':((faceObj.coordinates[0])/onePxWidthValue) + imageActualLeft + 'px'
                                            }">
                                            <div class="detected-face-box-remove-icon-sub-div" :ref="'face_box_delete_icon'+faceObj.uuid" @click="updateFaceSuggestion(faceObj, 'deleted')" :style="{'top':'-10px'}">
                                                <cancel-icon class="manual-drawn-box-remove-icon" style="width:25px;height:25px;"></cancel-icon>
                                            </div>
                                            <div style="width:100%;height:100%;display:inline-block" :style="objectStyle(faceObj.name, faceObj.status, 'box')">
                                            </div>
                                            <span v-if="(['confirmed','suggested'].includes(faceObj.status))" :ref="'face_name_label_'+faceObj.uuid" class="comm-face-name-label" :style="faceObj.name?'padding: 5px;':''" style="background: #00000078;display:inline-block;border-radius:4px;">{{faceObj.name}}</span>
                                            <div  :ref="'training_field_'+faceObj.uuid" class="personality-dropdown-wrapper">
                                                <div :id="'personality_dropdown_'+faceObj.uuid" :key="faceObj.uuid" style="min-width:175px;">
                                                    <Multiselect
                                                        v-model="selectedPersonalityMapper[faceObj.uuid]"
                                                        :options="personalitiesList"
                                                        :ref="'multiselect_'+faceObj.uuid"
                                                        :searchable="true"
                                                        :close-on-select="true"
                                                        :allow-empty="false"
                                                        label="display_name"
                                                        deselectLabel=""
                                                        selectLabel=""
                                                        selectedLabel=""
                                                        track-by="_id"
                                                        placeholder="Select Personality"
                                                        @open="updateActiveFace(faceObj)"
                                                        @select="onPersonalityChange($event, faceObj.uuid)"
                                                        @search-change="getSearchKeywordsOnKeyup($event)"
                                                        >
                                                        <!-- style="pointer-events:none" -->
                                                        <span slot="noResult">No results.</span>
                                                        <template slot="singleLabel" slot-scope="{ option }">{{option.name}}</template>
                                                    </Multiselect>
                                                </div>
                                                <!-- <span :ref="'addNewOption_'+faceObj.uuid" style="position: relative;display: inline-block;height: 40px;width: 100%;display: inline-flex;align-items: center;background: #393e42;padding: 0px 5px;border-radius: 0px 0px 10px 10px;">??? Add New</span> -->
                                            </div>    
                                        </div>    
                                    </template> 


                                 <!-- for custom facebox draw -->
                                    <div v-if="isCustomFaceboxVisible && customFaceboxCoOrdinates.width > 10 && customFaceboxCoOrdinates.height > 10 && cropper" class="comm-object-boxes halwa" style="position:absolute"
                                            :style="{ 
                                                'width': customFaceboxCoOrdinates.width+'px',
                                                'height': customFaceboxCoOrdinates.height +'px',
                                                'top': (customFaceboxCoOrdinates.top + customFaceboxCoOrdinates.height + 10) +'px',
                                                'left': customFaceboxCoOrdinates.left + 'px'
                                            }">
                                            <div class="manual-drawn-box-remove-icon-sub-div" :style="{'top':-(customFaceboxCoOrdinates.height) - 22+'px'}">
                                                <cancel-icon class="manual-drawn-box-remove-icon" @click="closeManualFaceDrawnBox()" style="width:25px;height:25px;"></cancel-icon>
                                            </div>

                                            <div class="manual-face-box-personality-dropdown">
                                                <div style="min-width:175px;">
                                                    <Multiselect
                                                        :options="personalitiesList"
                                                        :searchable="true"
                                                        :close-on-select="true"
                                                        :allow-empty="false"
                                                        label="display_name"
                                                        deselectLabel=""
                                                        selectLabel=""
                                                        selectedLabel=""
                                                        track-by="_id"
                                                        :placeholder="$t('Select Personality')"
                                                        @select="onManualBoxPersonalityChange($event)"
                                                        @search-change="getSearchKeywordsOnKeyup($event)"
                                                        >
                                                        <!-- style="pointer-events:none" -->
                                                        <span slot="noResult">No results.</span>
                                                        <template slot="singleLabel" slot-scope="{ option }">{{option.name}}</template>
                                                    </Multiselect>
                                                </div>
                                                <!-- <span :ref="'addNewOption_'+faceObj.uuid" style="position: relative;display: inline-block;height: 40px;width: 100%;display: inline-flex;align-items: center;background: #393e42;padding: 0px 5px;border-radius: 0px 0px 10px 10px;">??? Add New</span> -->
                                            </div>    
                                        </div>  
                                   <!-- END for custom facebox draw END -->

                                </div>
                                <div v-if="isVideoFile()" id="palyer_icons_wrapper">
                                    <ul style="padding:0px 5px;">
                                        <li title="Toggle Play-Pause (spacebar)" style="width:90px">
                                            <button style="width: 90px; display: flex; align-items: center;justify-content:center;" class="btn btn-outline-secondary play common-markinmarkout-action-btn" @click="playPauseToggle()">  
                                                <span v-show="isPlaying" class="common-play-pause">
                                                    <svg style="width:18px;height:18px;margin-top:1px !important" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg> 
                                                    <span style="margin-inline-start: -3px;">{{$t('Pause')}}</span> 
                                                </span>   
                                                <span v-show="!isPlaying" class="common-play-pause">
                                                    <svg  style="width:18px;height:18px;;margin-top:1px !important" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M10 8.64L15.27 12 10 15.36V8.64M8 5v14l11-7L8 5z"/></svg>
                                                    <span>{{$t('Play')}}</span>
                                                    <span style="visibility:hidden;"></span>
                                                </span> 
                                            </button>
                                        </li>
                                        <li title="Backward 1 Second (9)"><button class="btn btn-outline-secondary common-markinmarkout-action-btn" @click="forwardBackwardVideoBy1Sec('backward')">-1S</button></li>
                                        <li title="Forward 1 Second (0)"><button class="btn btn-outline-secondary common-markinmarkout-action-btn" @click="forwardBackwardVideoBy1Sec('forward')">+1S</button></li>
                                        <li title="Backward 1 Frame (-)"><button class="btn btn-outline-secondary common-markinmarkout-action-btn" @click="forwardBackwardVideoByFrame('backward')">-1F</button></li>
                                        <li title="Forward 1 Frame (=)"><button class="btn btn-outline-secondary common-markinmarkout-action-btn" @click="forwardBackwardVideoByFrame('forward')">+1F</button></li>
                                        <li title="Fast Forward" style="margin-inline-end:6px;width:50px"><button class="btn btn-outline-secondary common-markinmarkout-action-btn" @click="updateFastwardValue('forward')" style="width:50px;">FF</button></li>
                                        <li v-if="currentVideoSpeed != 1" style="display: flex;align-items: center;color: #bcbcbc;margin-inline-start: 3px;">
                                            <span style="border: 1px solid #4a4a4a !important;border-radius: 15px !important;width: 40px;padding: 4px;text-align: center;font-size: 14px;background: #282d31 !important;">{{currentVideoSpeed}}x</span></li>
                                    </ul>

                                    <ul style="float:inline-end">
                                        <li title="Tag Face" style="margin-inline-end:6px;width:100px"><button class="btn btn-outline-secondary common-markinmarkout-action-btn" @click="openTagFacesWindow" style="width:100px;">{{$t('Tag Face')}}</button></li>
                                    </ul>
                                    <!-- <button class="btn btn-outline-secondary common-markinmarkout-action-btn" style="color:#eee !important" @click="captureFrame()">Extract Frame</button> -->
                                    <!-- **************dont remove************* -->
                                    <!-- <div class="img-capture-btn comm-forward-icon" style="float:rght;width:50px" @click="resetVideoSpped">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-brush-fill svg-tools-color" viewBox="0 0 16 16" style="fill:currentColor !important;">
                                            <path d="M15.825.12a.5.5 0 0 1 .132.584c-1.53 3.43-4.743 8.17-7.095 10.64a6.067 6.067 0 0 1-2.373 1.534c-.018.227-.06.538-.16.868-.201.659-.667 1.479-1.708 1.74a8.118 8.118 0 0 1-3.078.132 3.659 3.659 0 0 1-.562-.135 1.382 1.382 0 0 1-.466-.247.714.714 0 0 1-.204-.288.622.622 0 0 1 .004-.443c.095-.245.316-.38.461-.452.394-.197.625-.453.867-.826.095-.144.184-.297.287-.472l.117-.198c.151-.255.326-.54.546-.848.528-.739 1.201-.925 1.746-.896.126.007.243.025.348.048.062-.172.142-.38.238-.608.261-.619.658-1.419 1.187-2.069 2.176-2.67 6.18-6.206 9.117-8.104a.5.5 0 0 1 .596.04z"/>
                                            <title>Capture</title>
                                        </svg>
                                    </div>
                                    <div class="reset-btn comm-forward-icon" style="float:rght" @click="resetVideoSpped">
                                        <span>Reset</span>
                                    </div> -->
                                    <!-- ***************************-->
                                </div>    
                            </div>
                            <div class="face-lists-panel">
                                <div style="display: inline-flex;align-items: center;width: 100%;">
                                    <h4 style="color: #dadada; margin-bottom: 0px; height: 35px; width: 50%;height: 100%;">{{$t('Faces')}}</h4>
                                    <div class="object-filter-wrapper">
                                        <!-- <input
                                            type="text"
                                            v-model="search"
                                            class="rounded text-light search-bar"
                                            placeholder="Search Faces"/> -->
                                        <div style="position:relative;" class="search-bar-comm-style" :style="toggleFaceSearch?'width:100%':''">
                                            <div class="icon-background-on-hover">    
                                                <svg @click="reloadThePage()" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#bbb" class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                                                    <title>{{$t('Refresh')}}</title>
                                                    <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"/>
                                                    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"/>
                                                </svg>
                                            </div>    
                                            <input
                                                v-if="toggleFaceSearch"
                                                type="text"
                                                v-model="search"
                                                class="rounded text-light search-bar"
                                                :placeholder="$t('Search Face')"
                                                ref="ObjetSearchBar"/>

                                            <svg v-if="toggleFaceSearch" @click="toggleFaceSearch = false; " xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#bbb" class="bi bi-x-lg" viewBox="0 0 16 16" style="position: absolute;inset-inline-end :6px;top: 14px;">
                                                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                                            </svg>
                                            <div v-else-if="!toggleFaceSearch" @click="faceSearch()" class="search-icon-wrapper icon-background-on-hover channel-create-icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#bbb" class="bi bi-search" viewBox="0 0 16 16">
                                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                                                    <title>{{$t('Search Face Name')}}</title>
                                                </svg>
                                            </div>  
                                        </div>                                        
                                    </div>
                                </div>    
                                <div style="height: calc(100% - 50px); width: 100%;display: inline-block;overflow: auto;padding:10px 0px;" ref="facesWindow">    
                                    <div v-if="frameJobs && frameJobs.length>0" class="upload-progress-bar">
                                        <div v-for="file in frameJobs" :key="file.job_id" class="d-flex h-100 upload-bars" :style="{'border-left':'2px solid'+ file.randomColor}" style="width:100%;margin-bottom:10px;">
                                            <div class="edit-upload-info mr-1 ml-1">
                                                <div v-if="fileInfo.mime_type.startsWith('video/') && (file.state == 'FAILED' || file.state == 'ABORTED')" @click="highlightSelectedObject(file, true)" :key="file.job_id">
                                                    <svg v-if="playingRegionUid == file.job_id" xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" class="bi bi-pause-fill" viewBox="0 0 16 16">
                                                        <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"/>
                                                    </svg>
                                                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="#01868c" class="bi bi-play-fill" viewBox="0 0 16 16">
                                                        <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/>
                                                    </svg>
                                                </div>
                                                <div v-else v-html="getSvgIconsOfMediaTypes()" class="svg-icons-display"></div>
                                            </div>
                                                <div class="file-name-with-progress-bar-wrapper" >
                                                    <div class="file-name-wrapper">
                                                        <div class="file-name-display" :title="file.resource_name">
                                                            <span >{{file.resource_name}}</span>
                                                        </div>
                                                        <span v-if="fileInfo.mime_type.startsWith('video/')" style="font-size:11px;float:inline-start;color:#ac92cf;width:100%;text-align:start">Face Detection - {{file.sub_job_name}}</span>
                                                        <!-- <div class="progress-bar-wrapper" v-if="file.state == 'IN_PROGRESS'">
                                                                <div class="progress-percentage-display">{{Math.round(file.status_info.progress) + '%'}}</div>
                                                                <div class="progress">
                                                                    <div class="progress-bar" role="progressbar" :style="{width:file.status_info.progress + '%'}" :aria-valuenow="file.status_info.progress" aria-valuemin="0" aria-valuemax="100"></div>
                                                                </div>
                                                        </div> -->
                                                    </div>
                                                </div>
                                                <div class="file-upload-status-display-wrapper">
                                                    <div class="file-upload-status">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" v-if="file.state == 'COMPLETED'" fill="green" class="bi bi-check-circle-fill ml-2 completed-files" viewBox="0 0 16 16">
                                                            <title>{{$t('COMPLETED')}}</title>
                                                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                                                        </svg>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="orange" v-if="file.state == 'QUEUED'" class="bi bi-clock-fill ml-2" viewBox="0 0 16 16">
                                                            <title>{{$t('QUEUED')}}</title>
                                                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                                                        </svg>
                                                        <template v-if="file.state == 'FAILED' || file.state == 'ABORTED'">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#cc6464" class="bi bi-x-circle-fill ml-2" viewBox="0 0 16 16">
                                                                <title v-if="file.force_fail">{{file.state}} : {{file.error_message}}</title>
                                                                <title v-else-if="fileInfo.mime_type.startsWith('video/')">{{file.state}} : Frame already submitted.</title>
                                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
                                                            </svg>
                                                            <svg v-if="fileInfo.mime_type.startsWith('video/')" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-person-bounding-box" viewBox="0 0 16 16" style="margin-inline-start: 10px;" @click="openTagFacesWindow(file)">
                                                                <title>{{$t('Tag Face')}}</title>
                                                                <path d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5z"/>
                                                                <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
                                                            </svg>
                                                        </template>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#dd8518" v-if="file.state == 'INITIALIZING'" class="bi bi-clock-fill ml-2" viewBox="0 0 16 16">
                                                            <title>{{$t('INITIALIZING')}}</title>
                                                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                                                        </svg>
                                                        <div v-if="file.state == 'IN_PROGRESS'" style="display:inline-flex;width:96%;justify-content:center">
                                                            <div class="progress" :data-percentage="parseInt(file.status_info.progress)">
                                                                <span class="progress-left">
                                                                    <span class="progress-bar"></span>
                                                                </span>
                                                                <span class="progress-right">
                                                                    <span class="progress-bar"></span>
                                                                </span>
                                                                <div :id="file.job_id" class="progress-value">
                                                                    <div>
                                                                        {{parseInt(file.status_info.progress)}}%<br>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#b43131" class="bi bi-x ml-2 remove-selected-file"  v-if="file.state == 'IN_PROGRESS'" :id="file.fileUID + '/' + file.jobId" v-on:click="discardSelectedFileFromUpload(file.fileUID,file.jobId,file.status)" viewBox="0 0 16 16">
                                                            <title>Remove File</title>
                                                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                                        </svg> -->
                                                    </div>
                                                </div>
                                        </div>
                                    </div>
                                    <div v-show="confirmedInOutObjects.length>0" class="confirmed-faces-list-wrapper">    
                                        <div class="comm-object-label-parent" v-for="items in confirmedInOutObjects" :key="items[0].uuid">
                                            <div v-if="items.length > 0 && fileInfo.mime_type.startsWith('video')" class="transcript-timecode-wrapper" @click="highlightSelectedObject(items[0])" :key="items[0].uuid">
                                                <svg v-if="playingRegionUid == items[0].uuid" xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" class="bi bi-pause-fill" viewBox="0 0 16 16">
                                                    <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"/>
                                                </svg>
                                                <svg v-else xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="#01868c" class="bi bi-play-fill" viewBox="0 0 16 16">
                                                    <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/>
                                                </svg>
                                                <div class="thumbnail-view-duration-label" style="overflow-wrap:anywhere">
                                                    <template v-if="items[0].media_in == items[0].media_out">
                                                        {{getDurationFormatAsHHorMMSS(items[0].media_in)}}
                                                    </template>
                                                    <template v-else>
                                                        {{getDurationFormatAsHHorMMSS(items[0].media_in) + ' - ' + getDurationFormatAsHHorMMSS(items[0].media_out)}}
                                                    </template>
                                                </div>
                                            </div>
                                            <div style="width:100%">
                                                <template v-for="item in items">
                                                    <div v-if="item.name && Object.keys(item).includes('name') && (!item.manually_deleted)" @click="highlightSelectedObject(item)" class="comm-object-label-child" :key="item.uuid">
                                                        <div class="comm-object-label-sub-child" :ref="'face_label_'+item.uuid">    
                                                            <div v-if="checkProfileImageExist(item).isProfileImageExist" class='user-name-or-image'>
                                                                <img :src="getProxyConvertedURL(checkProfileImageExist(item).profile_image)" @error="replaceWithUserIcon($event,item.name)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
                                                            </div>
                                                            <div v-else class="user-name-or-image" :title="item.name" :style="style(item.name)" >{{item.name.split("")[0]}}</div>
                                                            <span v-if="'display_name' in item" style="padding: 1px 2px 1px 6px; border-radius: 10px;font-size: 12px;float:inline-start;font-size:16px;display: inline-flex;align-items: center;word-break: break-all">  
                                                                {{ item.display_name}}
                                                            </span>
                                                            <span v-else style="padding: 1px 6px; border-radius: 10px;font-size: 12px;float:inline-start;font-size:16px;display: inline-flex;align-items: center;word-break: break-all"> <!-- :style="objectStyle(item.name, 'label')"-->    
                                                                {{ item.name}}
                                                            </span>
                                                        </div>    
                                                        <div @click="updateFaceSuggestion(item, 'deleted')" class="decetected-face-delete-wrapper">
                                                            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash3" viewBox="0 0 16 16" style="fill: #b3b3b3;position: relative;bottom: 3px;inset-inline-start:5px">
                                                                <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"/>
                                                            </svg> -->
                                                            <cancel-icon class="face-close-icon" style="width:24px;height:24px;"></cancel-icon>
                                                        </div>
                                                    </div>      
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="isSuggestionExists" style="height: 45px; width: 100%;padding: 10px 0px;border-bottom: 1px solid #302f2f;">
                                        <h5>{{$t('Suggestions')}}</h5>
                                    </div>
                                    <div class="suggested-faces-list-wrapper"> 
                                        <div class="comm-object-label-parent" v-for="items in suggestedInOutObjects" :key="items[0].uuid">
                                            <div v-if="items.length > 0 && fileInfo.mime_type.startsWith('video')" class="transcript-timecode-wrapper" @click="highlightSelectedObject(items[0])" :key="items[0].uuid">
                                                <svg v-if="playingRegionUid == items[0].uuid" xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" class="bi bi-pause-fill" viewBox="0 0 16 16">
                                                    <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"/>
                                                </svg>
                                                <svg v-else xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="#01868c" class="bi bi-play-fill" viewBox="0 0 16 16">
                                                    <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/>
                                                </svg>
                                                <div class="thumbnail-view-duration-label" style="overflow-wrap:anywhere">
                                                    <template v-if="items[0].media_in == items[0].media_out">
                                                        {{getDurationFormatAsHHorMMSS(items[0].media_in)}}
                                                    </template>
                                                    <template v-else>
                                                        {{getDurationFormatAsHHorMMSS(items[0].media_in) + ' - ' + getDurationFormatAsHHorMMSS(items[0].media_out)}}
                                                    </template>
                                                </div>
                                            </div>
                                            <div style="width:100%">
                                                <template v-for="item in items">
                                                    <div v-if="item.name && Object.keys(item).includes('name')" @click="highlightSelectedObject(item)" class="comm-object-label-child" :key="item.uuid">
                                                        <div class="comm-object-label-sub-child" :ref="'face_label_'+item.uuid">    
                                                            <div v-if="checkProfileImageExist(item).isProfileImageExist" class='user-name-or-image'>
                                                                <img :src="getProxyConvertedURL(checkProfileImageExist(item).profile_image)" @error="replaceWithUserIcon($event,item.name)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
                                                            </div>
                                                            <div v-else class="user-name-or-image" :title="item.name" :style="style(item.name)" >{{item.name.split("")[0]}}</div>
                                                            <span v-if="'display_name' in item" style="padding: 1px 6px; border-radius: 10px;font-size: 12px;float:inline-start;font-size:16px;display: inline-flex;align-items: center;word-break: break-all">  
                                                                {{ item.display_name}}
                                                            </span>
                                                            <span v-else style="padding: 1px 6px; border-radius: 10px;font-size: 12px;float:inline-start;font-size:16px;display: inline-flex;align-items: center;word-break: break-all"> <!-- :style="objectStyle(item.name, 'label')"-->    
                                                                {{ item.name}}
                                                            </span>
                                                        </div>    
                                                        <div class="d-flex" style="align-items:center">
                                                            <save-icon @click.native="updateFaceSuggestion(item, 'confirmed')" style="width:20px;height:20px;margin-inline-start:10px"></save-icon>
                                                            <cancel-icon @click.native="updateFaceSuggestion(item, 'rejected')" style="width:24px;height:24px;margin-inline-start:10px"></cancel-icon>
                                                        </div> 
                                                    </div>      
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>  
                            </div>
                        </div>
                    </div>  
                </div>
            </div>
        </div>

        <div v-if="openAddNewPersonalityModel" class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog add-new-profile-model" role="document">
                <div class="modal-content">
                    <div class="modal-header p-2">
                        <h6 class="modal-title">{{$t('Add New Personality')}}</h6>
                        <button class="close text-white" data-dismiss="modal" aria-label="Close" @click="closeAddNewPersonalityModel()">
                            <span aria-hidden="true">
                                <cancel-icon class="close-icon" style="height: 30px !important;width: 30px !important;color: #fff;"></cancel-icon>
                            </span>
                        </button>
                    </div>
                    <div class="modal-body" style="padding:15px;height:auto !important">
                        <div class="project-fields-wrapper">
                            <div class="comm-project-fields">
                                <label class="input-field-label">{{$t('Name')}} *</label>
                                <div class="input-field-value-div">
                                    <input ref="personalityName1111" v-model="personalityName" type="text" autocomplete="off" tabindex="1" class="rounded text-light comm-input-field-style" style="float:inline-start;width:100%">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer p-0 primary-btn-style" style="position:relative;inset-inline-start:0px !important">
                        <button class="btn btn-outline-secondary" data-dismiss="modal" @click="closeAddNewPersonalityModel();">{{$t('Cancel')}}</button>
                        <button class="btn btn-outline-primary mr-2" @click='addNewPersonality()'>{{$t('Save')}}</button>
                    </div>
                </div>
            </div>
        </div>    
                    
        <tag-face-modal v-if="isCapturedFaceTag" @browsedPersonalities="tagBrowsedPersonalites" @closeTagFaceModal="resetPersonalityBrowser"> </tag-face-modal>
       


    </div>
    
</template>

<script>

import Utils from "../../components.utils.js"
import {mapActions,mapMutations,mapGetters} from "vuex";
import { NotifierConstants } from "../../components.constants";
import VideoPlayer from "../core/VideoPlayer.vue";
import Multiselect from "vue-multiselect";
import cancelIcon from "../core/InlineCancelField.vue";
import Constants from "../../components.constants.js";
import SaveIcon from "../core/InlineSaveField.vue";
import tagFaceWithVideo from "./tagFacesModal.vue"
import 'cropperjs/dist/cropper.css';
import Cropper from 'cropperjs';

    export default{
        props:["filesInfo", "faceDetectContext", "parentActivePersonalityId"],
        data(){
            return{
                isNewEntry:false,
                frameJobs:[],
                relativeFDFileUids:[],
                fdFrameUidParentUidMapper:[],
                activePersonalityId:null,
                selectedServiceDetails:{},
                serviceOptionList:[],
                name:"facedetection",
                parentRouteInfo:{},
                fileInfo:{},
                fileId : null,
                assetId:null,
                assetDetails:{},
                videoOptions: {
                    autoplay: false,
                    controls: true,
                    nativeTextTracks: true,
                    controlBar:{
                        'pictureInPictureToggle': false,
                        'remainingTimeDisplay': false,
                    },
                    sources: []
                },
                controller:{},
                isLoaded:false,
                currentVideoSpeed : 1,
                isPlaying: false,
                faceObjectList:[],
                search:null,
                openAddNewPersonalityModel:false,
                searchedKeywordForCreateNewPersonality:"",

                previewScreenWidth:0,
                previewScreenHeight:0,
                onePxWidthValue:0,
                onePxHeightValue:0,
                imageActualLeft:0,
                imageActualTop:0,
                selectedPersonalityMapper:{},
                personalitiesList:[],
                personalityInfoObj: [],
                personalityName:"",
                activeFace:{},
                toggleFaceSearch:false,
                isSuggestionExists:false,
                playingRegionUid:null,
                visionConfig:{},
                isCapturedFaceTag:false,
                tagForFailedJobs:{},
                cropper:null,
                isCustomFaceboxVisible: false,
                customFaceboxCoOrdinates: null,
                isCustomFaceboxEnabled:false,
                loadingImageForFateDetect:Utils.getLoadingGif(),
                isImageLoadedForFaceDetection:false,
                loadedImagePath:null
            }
        },
        components:{
            // "cancel-icon": CancelIcon,
            "video-player": VideoPlayer,
            Multiselect,
            'cancel-icon':cancelIcon,
            "save-icon": SaveIcon,
            "tag-face-modal":tagFaceWithVideo,
            // "tag-metadata": tagMetadataComponent,
        },

        methods:{
            enableDisableManualFaceboxSelection(){
                if(this.cropper){
                    this.cropper.clear();
                    this.isCustomFaceboxVisible = false;
                    this.customFaceboxCoOrdinates = null;
                }
                if(this.cropper.disabled){
                    this.isCustomFaceboxEnabled = true;
                    this.cropper.enable();
                }else{
                     this.isCustomFaceboxEnabled = false;
                     this.cropper.disable();
                }
            },

            onManualBoxPersonalityChange(selectedOption){
            //     let coOrdinatesData = null;
            //     let cropReturnInfo = this.getImageCropData();
            //     if(cropReturnInfo && cropReturnInfo != 'send_whole_image'){
            //        coOrdinatesData =  cropReturnInfo;
            //     }
            //    console.log(`[onManualBoxPersonalityChange][selectedOption]`,selectedOption,'Facebox data :',coOrdinatesData);

                if(selectedOption.display_name && selectedOption.display_name.toLowerCase().includes("+ create new")){
                    this.openAddNewPersonalityModel = true;
                    this.$nextTick(()=>{
                        this.$refs["personalityName1111"].focus();
                        if(selectedOption.display_name.length>0){
                            let stringWithQuotes = selectedOption.display_name;

                            // Remove double quotes using the replace() method
                            let stringWithoutQuotes = stringWithQuotes.replace(/"/g, '');

                            // Remove the "(+ create new)" part using substring()
                            let finalString = stringWithoutQuotes.substring(0, stringWithoutQuotes.indexOf('(+ create new)'));

                            this.personalityName = finalString.trim(); 
                        }    
                    });
                    return false;
                }
                this.createManualObject(selectedOption)
            },
            createManualObject(persoanlityObj){
                let coOrdinatesData = null;
                let cropReturnInfo = this.getImageCropData();
                if(cropReturnInfo && cropReturnInfo != 'send_whole_image'){
                   coOrdinatesData =  cropReturnInfo;
                }
               console.log(`[onManualBoxPersonalityChange][selectedOption]`,persoanlityObj,'Facebox data :',coOrdinatesData);


                let facePUTData = {
                        accuracy: "",
                        coordinates: coOrdinatesData,
                        end_frame: -1,
                        media_in: -1,
                        media_out: -1,
                        name: persoanlityObj.name,
                        display_name:persoanlityObj.display_name,
                        object_id: persoanlityObj._id,
                        personality_sync_required: true,
                        start_frame: -1,
                        status: "confirmed",
                        user_trained: true,
                        uuid: Utils.getUUID(),
                        manual_detection:true,
                };

                this.faceObjectList.push(facePUTData);
                let payload = {'version_id': this.fileInfo.version_id};
                if(this.isNewEntry){
                    payload["objects_info"] = this.faceObjectList
                    this.addNewFaceDetectionEntry(payload).then(data=>{
                            if(Utils.isAcceptedStatusCode(data.statusCode)){
                                this.$toast.success("Updated successfully.");
                                this.isNewEntry = false
                                this.closeAddNewPersonalityModel();
                                [].map.call(this.$el.querySelectorAll('.personality-dropdown-wrapper'),(el)=>{
                                    el.style.display = "none";
                                });
                                this.isCustomFaceboxVisible = false;
                                this.customFaceboxCoOrdinates = null;
                                this.cropper.clear()
                            }else{
                                this.$toast.error(data.message);
                            }
                        });
                }else{
                    let params={};
                    params["objects_info"] = this.faceObjectList
                    payload["params"] = params;
                    this.updatePersonlaityWithFace(payload).then((data)=>{
                        console.log(data)
                        this.closeAddNewPersonalityModel();
                        [].map.call(this.$el.querySelectorAll('.personality-dropdown-wrapper'),(el)=>{
                            el.style.display = "none";
                        });
                        this.isCustomFaceboxVisible = false;
                        this.customFaceboxCoOrdinates = null;
                        this.cropper.clear();
                    });
                }    
            },

            closeManualFaceDrawnBox(){
                if(confirm("Are you sure you want to remove the manually drawn face box?")){
                    if(this.cropper){
                        this.isCustomFaceboxVisible = false;
                        this.customFaceboxCoOrdinates = null;
                        this.cropper.clear();
                    }
                }    
            },
            
            handleKeydownEventOnFaceDetectionWindow(event){
                let keyCode = event.keyCode || event.which;
                if(keyCode == 27){ // ESC key
                    if(this.cropper){
                        this.isCustomFaceboxVisible = false;
                        this.customFaceboxCoOrdinates = null;
                        this.cropper.clear();
                    }
                    return true;
                }
            },
            getImageCropData(){
                const rectData = this.cropper.getData();
                if(rectData.x == 0 && rectData.y == 0 && rectData.width == 0 && rectData.height == 0){
                    return 'send_whole_image';
                }
                let x = parseInt(Math.round(rectData.x));
                if(x == null || isNaN(x)){
                    return null
                }
                let y =  parseInt(Math.round(rectData.y));
                let newWidth =  rectData.width;
                let newHeight =  rectData.height;
                return [x,y,parseInt(Math.round(x+newWidth)),parseInt(Math.round(y+newHeight))];
            },

            removeSelectedFaceBox(event){
                if(event.target && event.target.parentElement && event.target.parentElement.classList.contains('comm-object-boxes')){
                  return;
                }

                [].map.call(this.$el.querySelectorAll('.comm-object-boxes'),(el)=>{
                    el.style.boxShadow = "";
                });

                // [].map.call(this.$el.querySelectorAll('.comm-object-label-child'),(el)=>{
                //     el.style.boxShadow = "";
                // });
                [].map.call(this.$el.querySelectorAll('.comm-object-label-sub-child'),(el)=>{
                    el.style.boxShadow = "";
                });

                [].map.call(this.$el.querySelectorAll('.detected-face-box-remove-icon-sub-div'),(el)=>{
                    el.style.visibility = "hidden";
                });
            },
            
            resetPersonalityBrowser(){
                this.isCapturedFaceTag = false;
                this.tagForFailedJobs = {};
            },
            tagBrowsedPersonalites(personalities){
                let video = this.$refs.videoPlayerRef.$el.querySelector('video');
                if (video) {
                    let updatingForJob = false;
                    if(! video.paused){
                        this.playPauseToggle()
                    }
                    let inVal = Math.round(video.currentTime * 1000)
                    console.log("current time from video ********** ",inVal)
                    if(this.tagForFailedJobs && Object.keys(this.tagForFailedJobs).length > 0 && 'frame_timecode' in this.tagForFailedJobs){
                        updatingForJob = true;
                        inVal = this.tagForFailedJobs.frame_timecode;
                        console.log("current time from failed job ************",inVal)
                    }
                    console.log("calculated current time ************ ",inVal)
                    let newObjects = personalities.map(item => ({
                        accuracy: "",
                        coordinates: [],
                        end_frame: -1,
                        media_in: inVal,
                        media_out: inVal,
                        name: item.name,
                        object_id: item._id,
                        personality_sync_required: false,
                        start_frame: -1,
                        status: "confirmed",
                        user_trained: true,
                        uuid: Utils.getUUID()
                    }));

                    let payload = {};
                    let originalList = this.faceObjectList.filter(item => {
                        return !Object.hasOwnProperty.call(item, 'version_id');
                    });

                    let newList = originalList.concat(newObjects)
                    payload["version_id"] = this.fileInfo.version_id;
                    if(this.isNewEntry){
                        payload['objects_info'] = newList;
                        this.addNewFaceDetectionEntry(payload).then(data=>{
                            if(Utils.isAcceptedStatusCode(data.statusCode)){
                                this.$toast.success("Updated successfully.");
                                this.isNewEntry = false
                            }else{
                                this.$toast.error(data.message);
                            }
                            this.isCapturedFaceTag=false;
                        });
                    }else{
                        let params = {};
                        params["objects_info"] = newList;
                        payload.params = params;
                        this.updatePersonlaityWithFace(payload).then((data)=>{
                            console.log(data)
                            this.isCapturedFaceTag=false;
                        });
                    }
                    if(updatingForJob && this.tagForFailedJobs && Object.keys(this.tagForFailedJobs).length > 0 && 'frame_timecode' in this.tagForFailedJobs){
                        this.frameJobs = this.frameJobs.filter(job=>job.job_id != this.tagForFailedJobs.job_id);
                        this.tagForFailedJobs = {};
                    }
                }
            },
            getSvgIconsOfMediaTypes(){
                return `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 100 100">
                            <path d="M13.6 40.9c3.8 0 7-1.3 9.7-4 2.7-2.7 4-5.9 4-9.7 0-3.8-1.3-7-4-9.7-2.7-2.7-5.9-4-9.7-4-3.8 0-7 1.3-9.7 4-2.7 2.7-4 5.9-4 9.7 0 3.8 1.3 7 4 9.7 2.7 2.7 5.9 4 9.7 4zm20.5 20.5L22.7 50 0 72.7v13.6h100V54.5L70.5 25 34.1 61.4z" fill="#e89131">
                            </path>
                        </svg>`
            },
            formatedDate(date){
                return Utils.getDateFormat(date);
            },
            createFaceDetectionJob(){
                let payload = {
                    file_uid: this.fileInfo.file_uid,
                    version_id: this.fileInfo.version_id,
                    crop:[],
                    job_name: "Face Detection",
                    element_type: "file"
                }
                if(Object.keys(this.selectedServiceDetails).length){
                    payload["ai_registry_id"] = this.selectedServiceDetails.registry_id;
                }
                this.createNewJob(payload).then((data)=>{
                    if(Utils.isAcceptedStatusCode(data.statusCode)){
                        this.$toast.success("Face detection job submitted successfully.");
                        if('job_id' in data ){
                            this.relativeFDFileUids.push({'file_uid':this.fileInfo.file_uid, 'parent_job_id':data.job_id})
                            if(data.status_info && !('progress' in data.status_info)){
                                data['status_info'] = {"progress":0};
                            }
                            this.frameJobs.unshift(data)
                        }
                    }else{
                        this.$toast.error(data.message);
                    }
                });
            },
            style(name){
                let style = {
                    'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
                    'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
                }
                return style
            },

            objectStyle(name, status, type){
                console.log(name, type)
                let style = {};
                // if(type == 'label'){
                //     style = {
                //         'border':'1px solid #'+Utils.intToRGB(Utils.hashCode(name)),
                //         // 'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))+'30',
                //         // 'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
                //     }
                // }else{   
                    if(status == 'confirmed' && name){ // 'rejected' && status != 'deleted'){
                        style = {
                            'border':'3px solid #2abc2a'
                            // 'border':'3px solid #'+Utils.intToRGB(Utils.hashCode(name)),
                            // 'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))+'30',
                            // 'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
                        }
                    }else if(status == 'suggested' && name){
                        style = {
                            'border' :'3px solid #70b6fb'
                        }
                    }
                    else{
                        style = {
                            'border':'3px solid #d7d7d7',
                            // 'background-color':'#d7d7d7',
                            // 'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
                        }
                    }    
                // }    
                
                return style;
            },

            // getDurationInSecondsForMarkers(duration){
            //     return Utils.getDurationInHHorMMSS(this.getDurationInSeconds(duration))
            // },

            getDurationFormatAsHHorMMSS(duration){
                return Utils.getDurationInHHorMMSS(duration / 1000);
            },

            getDurationInSeconds(duration){
                let regex = new RegExp(":")
                if(regex.test(duration)){
                    return duration;
                }
                return duration;
                // return duration/1000;
            },

            checkProfileImageExist(faceObj){
                let profileImageObj = {};
                profileImageObj["isProfileImageExist"] = false;

                let profileIndex = this.personalityInfoObj.findIndex((obj)=>obj._id == faceObj.object_id);
                if(profileIndex >=0 && 'profile_image' in this.personalityInfoObj[profileIndex] && this.personalityInfoObj[profileIndex].profile_image){
                    profileImageObj["isProfileImageExist"] = true;
                    profileImageObj["profile_image"] = this.personalityInfoObj[profileIndex].profile_image;
                }
                return profileImageObj;
            },

            // getProfileImageById(faceObj){
            //     let profileImagePath = "";
            //     let profileIndex = this.personalitiesList.findIndex((obj)=>obj._id == faceObj.object_id);
            //     if(profileIndex >=0 && 'profile_image' in this.personalitiesList[profileIndex] && this.personalitiesList[profileIndex].profile_image){
            //         profileImagePath = this.personalitiesList[profileIndex].profile_image;
            //     }
            //     return profileImagePath;
            // },

            faceSearch(){
                this.toggleFaceSearch = !this.toggleFaceSearch;
                this.$nextTick(()=>{
                    if(this.$refs["ObjetSearchBar"])this.$refs["ObjetSearchBar"].focus()
                })
            },

            imagesLoadedCallback(event){
                if(this.isImageFile()){
                    console.log("client blound values.................", event.target.getBoundingClientRect())
            
                    let widthHeightRatio = event.target.naturalWidth/event.target.naturalHeight;
                    let newWidth = this.$refs.mainPreviewPanel.clientWidth;
                    let newHeight = newWidth/widthHeightRatio;
                    if (newHeight > this.$refs.mainPreviewPanel.clientHeight) {
                        newHeight = this.$refs.mainPreviewPanel.clientHeight;
                        newWidth = newHeight * widthHeightRatio;
                    }

                    event.target.style.width = newWidth +'px';
                    event.target.style.height = newHeight +'px';
                    this.isImageLoadedForFaceDetection = true;

                    this.$nextTick(()=>{
                        this.previewScreenWidth = this.$refs.mainPreviewPanel.clientWidth;
                        this.previewScreenHeight = this.$refs.mainPreviewPanel.clientHeight;

                        let proxyWidth = newWidth;
                        let proxyHeight = newHeight;
                        // let proxyWidth = this.fileInfo.width; //event.target.naturalWidth;
                        // let proxyHeight = this.fileInfo.height; 

                        this.onePxWidthValue = 1*(event.target.naturalWidth/proxyWidth);
                        this.onePxHeightValue = 1*(event.target.naturalHeight/proxyHeight);

                        // this.imageActualLeft = event.target.getBoundingClientRect().left;
                        // this.imageActualTop = event.target.getBoundingClientRect().top;
                        this.imageActualLeft = event.target.offsetLeft;
                        this.imageActualTop = event.target.offsetTop;


                        this.cropper = new Cropper(document.getElementById('face-detection-image'), {
                            aspectRatio: NaN,
                            background:false,
                            movable:false,
                            autoCrop:false,
                            cropBoxResizable: true,
                            scalable:false,
                            zoomable:false,
                            zoomOnTouch: false,
                            zoomOnWheel:false,
                            cropBoxMovable:true,
                            toggleDragModeOnDblclick: false,
                            guides: false,
                            highlight: false,
                            modal: false,
                            cropend: (event) =>{
                            console.log(`[cropend]`,event);
                            this.customFaceboxCoOrdinates = this.cropper.getCropBoxData();
                            this.isCustomFaceboxVisible = true;
                                [].map.call(this.$el.querySelectorAll('.personality-dropdown-wrapper'),(el)=>{
                                    el.style.display = "none";
                                });

                                [].map.call(this.$el.querySelectorAll('.detected-face-box-remove-icon-sub-div'),(el)=>{
                                    el.style.visibility = "hidden";
                                });

                                if(document.getElementsByClassName("manual-drawn-box-remove-icon-sub-div") && document.getElementsByClassName("manual-drawn-box-remove-icon-sub-div")[0]){
                                    document.getElementsByClassName("manual-drawn-box-remove-icon-sub-div")[0].style.visibility = "visible";
                                }

                            console.log(`this.customFaceboxCoOrdinates`,this.customFaceboxCoOrdinates,this.isCustomFaceboxVisible);
                            },
                            cropmove: () =>{
                            this.customFaceboxCoOrdinates = null;
                            this.isCustomFaceboxVisible = false;
                            },
                            ready:()=>{
                            this.cropper.disable();
                            this.isCustomFaceboxEnabled = false;
                                [].map.call(this.$el.querySelectorAll('.detected-face-box-remove-icon-sub-div'),(el)=>{
                                    el.style.visibility = "hidden";
                                });

                                if(document.getElementsByClassName("manual-drawn-box-remove-icon-sub-div") && document.getElementsByClassName("manual-drawn-box-remove-icon-sub-div")[0]){
                                    document.getElementsByClassName("manual-drawn-box-remove-icon-sub-div")[0].style.visibility = "visible";
                                }
                            }
                        });

                    });
                }    
            },

            highlightSelectedObject(faceObject, fromFailedJob = false){
                if(this.fileInfo.mime_type.startsWith("image")){
                    [].map.call(this.$el.querySelectorAll('.comm-object-boxes'),(el)=>{
                        el.style.boxShadow = "";
                    });

                    // [].map.call(this.$el.querySelectorAll('.comm-object-label-child'),(el)=>{
                    //     el.style.boxShadow = "";
                    // });
                    [].map.call(this.$el.querySelectorAll('.comm-object-label-sub-child'),(el)=>{
                        el.style.boxShadow = "";
                    });
                    
                    // document.querySelectorAll(".comm-object-boxes").style.boxShadow = "none";
                    if(this.$refs["face_"+faceObject.uuid] && this.$refs["face_"+faceObject.uuid][0])this.$refs["face_"+faceObject.uuid][0].style.boxShadow = "0px 0px 4px 1px #040404";
                    if(this.$refs["face_label_"+faceObject.uuid] && this.$refs["face_label_"+faceObject.uuid][0])this.$refs["face_label_"+faceObject.uuid][0].style.boxShadow = "0px 0px 3px 1px #7f7f7f";
                    this.showPersonalityDropdown(faceObject);
                }else if(this.fileInfo.mime_type.startsWith("video")){
                    if(fromFailedJob){
                        if(this.playingRegionUid && this.playingRegionUid == faceObject.job_id ){
                            this.playingRegionUid = null;
                            this.controller.player.pause();
                        }else{    
                            this.playingRegionUid = faceObject.job_id;
                            this.controller.player.currentTime(faceObject.frame_timecode/1000);
                            if (this.controller.player.paused()) this.controller.player.play();
                        }
                    }else{
                        if(this.playingRegionUid && this.playingRegionUid == faceObject.uuid ){
                            this.playingRegionUid = null;
                            this.controller.player.pause();
                        }else{    
                            this.playingRegionUid = faceObject.uuid;
                            this.controller.player.currentTime(faceObject.media_in/1000);
                            if (this.controller.player.paused()) this.controller.player.play();
                        }
                    }
                }    
            },
            formatDurationHHMMSS_or_MMSS(duration) {
                return Utils.getExactDuationInSeconds(duration , this.frameRate, '.');
            },
            getDurationFormat(duration){
                const date = new Date(duration * 1000); // convert to milliseconds
                const hours = date.getUTCHours();
                if(hours > 0){
                    return '00:00:00.00'
                }else{
                    return '00:00.00'
                }
            },
            setProgressLabel(duration){
                try{
                    [].forEach.call(document.querySelectorAll(`.player-current-time-division`),(el) => {
                        el.remove();
                    });
                }catch(e){console.log(e)}
                let progressBar = this.$refs.videoPlayerRef.$el.querySelector('.vjs-control-bar');
                let currentProgressEl = document.createElement('div');
                currentProgressEl.classList.add('player-current-time-division');
                currentProgressEl.innerHTML = `<span class="currrent-time">${this.getDurationFormat(duration)}</span> <span class="time-division-label">/</span> <span class="full-time-of-time-division">${this.formatDurationHHMMSS_or_MMSS(duration)}</span>`;
                progressBar.insertBefore(currentProgressEl,progressBar.querySelector('.vjs-fullscreen-control.vjs-control'));
            },

            regionPlayedHandler(){
                this.playingRegionUid = null;
            },

            showPersonalityDropdown(faceObject){
                [].map.call(this.$el.querySelectorAll('.comm-object-boxes'),(el)=>{
                    el.style.boxShadow = "";
                });

                // [].map.call(this.$el.querySelectorAll('.comm-object-label-child'),(el)=>{
                //     el.style.boxShadow = "";
                // });
                [].map.call(this.$el.querySelectorAll('.comm-object-label-sub-child'),(el)=>{
                    el.style.boxShadow = "";
                });

                [].map.call(this.$el.querySelectorAll('.detected-face-box-remove-icon-sub-div'),(el)=>{
                    el.style.visibility = "hidden";
                });

                if(document.getElementsByClassName("manual-drawn-box-remove-icon-sub-div") && document.getElementsByClassName("manual-drawn-box-remove-icon-sub-div")[0]){
                    document.getElementsByClassName("manual-drawn-box-remove-icon-sub-div")[0].style.visibility = "hidden";
                }
                
                // document.querySelectorAll(".comm-object-boxes").style.boxShadow = "none";
                if(this.$refs["face_"+faceObject.uuid] && this.$refs["face_"+faceObject.uuid][0])this.$refs["face_"+faceObject.uuid][0].style.boxShadow = "0px 0px 4px 1px #040404";
                if(this.$refs["face_label_"+faceObject.uuid] && this.$refs["face_label_"+faceObject.uuid][0])this.$refs["face_label_"+faceObject.uuid][0].style.boxShadow = "0px 0px 3px 1px #7f7f7f";
                if(this.$refs["face_box_delete_icon"+faceObject.uuid] && this.$refs["face_box_delete_icon"+faceObject.uuid][0])this.$refs["face_box_delete_icon"+faceObject.uuid][0].style.visibility = "visible";
                [].map.call(this.$el.querySelectorAll('.personality-dropdown-wrapper'),(el)=>{
                    el.style.display = "none";
                });
                this.isCustomFaceboxVisible = false; //this is for hide the manual drawn face box

                [].map.call(this.$el.querySelectorAll('.comm-face-name-label'),(el)=>{
                    el.style.display = "inline-block";
                });
                
                this.$nextTick(() => {
                    if(this.$refs["training_field_"+faceObject.uuid] && this.$refs["training_field_"+faceObject.uuid][0]){
                        this.$refs["training_field_"+faceObject.uuid][0].style.setProperty('display', 'inline-block', 'important');
                    }
                    if(this.$refs["face_name_label_"+faceObject.uuid] && this.$refs["face_name_label_"+faceObject.uuid][0])this.$refs["face_name_label_"+faceObject.uuid][0].style.display = "none";
                    if('name' in faceObject && faceObject.name && faceObject.status != 'rejected' && faceObject.status != 'deleted'){
                        let profileObjectFiltered = this.personalityInfoObj.find((obj)=>obj._id == faceObject.object_id);
                        // Object.assign(this.selectedPersonality,this.personalityInfoObj.find((obj)=>obj._id == faceObject.object_id));
                        let persoanlityObj = {};
                        if(profileObjectFiltered){
                            profileObjectFiltered["name"] = faceObject.name;
                            persoanlityObj = profileObjectFiltered;
                        }else{
                            persoanlityObj["name"] = faceObject.name;
                            persoanlityObj["_id"] = faceObject.object_id;
                            persoanlityObj["profile_image"] = "";
                        }
                        this.selectedPersonality = persoanlityObj;
                        this.$set(this.selectedPersonalityMapper, faceObject.uuid, persoanlityObj);
                    }else{
                        this.selectedPersonality = null;
                        this.selectedPersonalityMapper = {};
                    }
                });    
            },

            getSearchKeywordsOnKeyup(option){
                let searchingKeyword = option;
                this.getPersonlities(searchingKeyword);
            },

            onPersonalityChange(option, uuid){
                if(option.display_name && option.display_name.toLowerCase().includes("+ create new")){
                    this.openAddNewPersonalityModel = true;
                    this.$nextTick(()=>{
                        this.$refs["personalityName1111"].focus();
                        if(option.display_name.length>0){
                            let stringWithQuotes = option.display_name;

                            // Remove double quotes using the replace() method
                            let stringWithoutQuotes = stringWithQuotes.replace(/"/g, '');

                            // Remove the "(+ create new)" part using substring()
                            let finalString = stringWithoutQuotes.substring(0, stringWithoutQuotes.indexOf('(+ create new)'));

                            this.personalityName = finalString.trim(); 
                        }    
                    });
                    return false;
                }
                this.selectedPersonality = option;
                this.$set(this.selectedPersonalityMapper, uuid, option);
                this.updateWithProfile(this.selectedPersonality, false);

                [].map.call(this.$el.querySelectorAll('.comm-face-name-label'),(el)=>{
                    el.style.display = "inline-block";
                });
            },

            updateActiveFace(faceObj){
                this.activeFace = faceObj;
            },


            addNewPersonality(){
                let payload = {};
                if(this.personalityName != ""){
                    payload["name"] = this.personalityName;
                }else{
                    alert("Empty personality name");
                    return false;
                }

                payload["profile_image"] = null;
                payload['alias'] = [];
                payload["file_uids"] = [];

                this.addNewPersonalityFromServer(payload).then((data)=>{
                    if (Constants.acceptedStatusCodes.includes(data.statusCode)){
                        let profileData = {}
                        profileData["name"] = data.upserted_data.name;
                        profileData["display_name"] = data.upserted_data.name;
                        profileData["alias"] = [];
                        profileData["_id"] = data.upserted_data._id;
                        profileData["profile_image"] = data.upserted_data.profile_image;
                        profileData["file_uids"] = data.upserted_data.file_uids;
                        // let profileIndx = this.personalityInfoObj.findIndex((obj)=>obj._id == data.upserted_data._id);
                        // if(profileIndx<0){
                        //     this.personalityInfoObj.push(profileData);
                        // }

                        let profileIndx = this.personalitiesList.findIndex((obj)=>obj._id == data.upserted_data._id);
                        if(profileIndx<0){
                            this.personalitiesList.push(profileData);
                        }

                        this.closeAddNewPersonalityModel();
                        if(this.isCustomFaceboxVisible){
                            this.createManualObject(profileData);
                        }else{
                            this.updateWithProfile(profileData, true);
                        }
                    }    
                });

            },

            updateFaceSuggestion(faceObj, status){
                let allowToUpdate = false;
                if(status == 'deleted'){
                    if (confirm(`Are you sure you want to delete '${faceObj.display_name}' ?`)) {
                        allowToUpdate = true;
                    }else{
                        allowToUpdate = false
                    }
                }else{
                    allowToUpdate = true;
                }  
                
                if(allowToUpdate){
                    if ('version_id' in faceObj){
                        //update specific frame
                        let originalList = this.faceObjectList.filter(item => (('version_id' in item) && item.version_id == faceObj.version_id));
                        let faceIdx = originalList.findIndex((obj)=>obj.uuid == faceObj.uuid);
                        originalList[faceIdx].status = status;
                        originalList[faceIdx].user_trained = true;
                        if(status == 'rejected' || status == 'deleted'){
                            originalList[faceIdx].name = "";
                            originalList[faceIdx].display_name = "";
                            originalList[faceIdx].object_id = "";
                        }
                        if(status == "deleted"){
                            originalList[faceIdx]["manually_deleted"] = true;
                        }
                        let payload = {params:{objects_info : originalList}, 'version_id':faceObj.version_id};
                        this.updatePersonlaityWithFace(payload).then((data)=>{
                            console.log(data)
                        });
                    }else{
                        //update parent file
                        let payload ={};
                        let params = {};
                        let originalList = this.faceObjectList.filter(item => !('version_id' in item));
                        let faceIdx = originalList.findIndex((obj)=>obj.uuid == faceObj.uuid);
                        originalList[faceIdx].status = status;
                        originalList[faceIdx].user_trained = true;
                        if(status == 'rejected' || status == 'deleted'){
                            originalList[faceIdx].name = "";
                            originalList[faceIdx].display_name = "";
                            originalList[faceIdx].object_id = "";
                        }
                        if(status == "deleted"){
                            originalList[faceIdx]["manually_deleted"] = true;
                        }
                        params["objects_info"] = originalList;
                        payload.params = params;
                        payload["version_id"] = this.fileInfo.version_id;
                        this.updatePersonlaityWithFace(payload).then((data)=>{
                            console.log(data)
                        });
                    }
                }    

            },

            updateWithProfile(personalityInfo, isNewProfile = false){
                let payload = {};
                let facePUTData = Object.assign({}, this.activeFace);
                // facePUTData["coordinates"] = this.activeFace.coordinates;
                // facePUTData["uuid"] = this.activeFace.uuid;
                facePUTData["user_trained"] = true;
                facePUTData["status"] = 'confirmed';
                // if(isNewProfile){
                //     if(this.personalityName != ""){
                //         facePUTData["name"] = this.personalityName;
                //     }else{
                //         alert("Empty personality name");
                //         return false;
                //     }
                // }else{
                //     facePUTData["name"] = this.selectedPersonalityMapper[this.activeFace.uuid].name;
                // }  
                
                if(isNewProfile && personalityInfo && Object.keys(personalityInfo).length>0){
                    facePUTData["name"] = personalityInfo.name;
                    facePUTData['display_name'] =  personalityInfo.display_name;
                    facePUTData["object_id"] = personalityInfo._id;
                    // facePUTData["_id"] = personalityInfo._id;
                }else{
                    facePUTData["name"] = this.selectedPersonalityMapper[this.activeFace.uuid].name;
                    facePUTData["display_name"] = this.selectedPersonalityMapper[this.activeFace.uuid].display_name;
                    facePUTData["object_id"] = this.selectedPersonality["_id"]
                }
                
                facePUTData["personality_sync_required"] = true

                let faceIdx = this.faceObjectList.findIndex((obj)=>obj.uuid == this.activeFace.uuid);
                
                this.faceObjectList[faceIdx] = facePUTData;

                let params = {};
                params["objects_info"] = this.faceObjectList;

                payload.params = params;
                payload["version_id"] = this.fileInfo.version_id;
                this.updatePersonlaityWithFace(payload).then((data)=>{
                    console.log(data)
                    this.closeAddNewPersonalityModel();
                    [].map.call(this.$el.querySelectorAll('.personality-dropdown-wrapper'),(el)=>{
                        el.style.display = "none";

                    });
                     this.isCustomFaceboxVisible = false; //this is for hide the manual drawn face box
                });
            },

            closeAddNewPersonalityModel(){
                this.openAddNewPersonalityModel=false;
                this.selectedPersonalityMapper = {};
            },


            setAssetInfo(info){
                // try{
                //     if(this.videoFrameCallbackID) {
                //         console.log(`Cancelled old [videoFrameCallback][${this.videoFrameCallbackID}]`);
                //         this.controller.player.cancelAnimationFrame(this.videoFrameCallbackID);
                //     }
                // }catch(e){console.log(e)}
                this.assetDetails = {}
                Object.assign(this.assetDetails, info)
                // if(Object.keys(this.assetDetails).includes("custom_metadata")){
                //     Object.assign(this.assetDetails["custom_metadata"], this.assetDetails.custom_metadata);
                // }else{
                //     this.assetDetails["custom_metadata"] = [];
                // }     
                if('mime_type' in this.assetDetails){
                    if (this.assetDetails.mime_type.startsWith("video")){
                        this.videoOptions.sources.push({
                            src:this.getLowresPath(this.assetDetails),
                            type: "video/mp4"
                        })
                    }
                    // else if (this.assetDetails.mime_type.startsWith("audio")){
                    // this.audioUrl = this.getAudiowaveform(this.assetDetails)
                    // }
                }
                // else if(this.assetDetails && this.assetDetails.asset_type && this.assetDetails.asset_type == 'subclip'){
                //     this.getMasterAssetWithSubclip(this.assetDetails).then(data => {
                //         this.videoOptions.sources.push({
                //             src:this.getLowresPath(data),
                //             type: "video/mp4"
                //         })
                //         this.$refs.videoPlayerRef.restartPlayer(this.videoOptions.sources,()=>{
                //             this.addSubclipMarkers(this.assetDetails);
                //         });
                //     });
                // }
                this.isLoaded=true 
            },

            refreshFileInfoAndShowAsset(fileId){
                let payload = {}
                if (this.assetId && Utils.getCookieValue("context") == 'catalogs-display'){
                    payload.params = {assetId: this.assetId}
                    this.getAssetInfoFromServer(payload).then((data) => {
                        this.setAssetInfo(data["asset"])
                        // this.getFacesDataFromServer();
                    })
                }else{
                    payload.params = {fileId: fileId, metadata:true}
                    this.getFileInfoFromServer(payload).then((data) => {
                        this.setAssetInfo(data["file"])
                        // this.getFacesDataFromServer();
                    })
                }
            },

            isImageFile(){
                try {
                    if('mime_type' in this.fileInfo){
                    return this.fileInfo.mime_type.startsWith("image")  ||  this.fileInfo.mime_type.startsWith("audio")   || this.fileInfo.mime_type.startsWith("doc")
                    }
                } catch (err) {
                    console.error(`[isImageFile][files][Error while checking filetype-${err}]`)
                }
                return false
            },
            isVideoFile(){
                try {
                    if(this.fileInfo && this.fileInfo.asset_type && this.fileInfo.asset_type == 'subclip'){
                    return true;
                    }
                } catch (err) {
                    console.error(`[isVideoFile][files][1][Error while checking filetype-${err}]`)
                }
                try {
                    if('mime_type' in this.fileInfo){
                        return this.fileInfo.mime_type.startsWith("video")
                    }
                } catch (err) {
                    console.error(`[isVideoFile][files][2][Error while checking filetype-${err}]`)
                }
                return false
            },

            setController(controller){
                this.controller = controller;
                if(this.controller.player)this.controller.player.on('pause', this.regionPlayedHandler);
            },

            videoPlaytoggle(){
                this.playerListener();
                try{
                    this.setProgressLabel(this.controller.player.duration());
                }catch(e){console.log(e)}
            },

            playerListener(){
                let video = this.$refs.videoPlayerRef.$el.querySelector('video');
                video.addEventListener("pause", this.updatePlayerPauseAction);
                    
                video.addEventListener("play",  this.updatePlayerPlayAction);    
            },   

            updatePlayerPauseAction(){
                // let video = this.$refs.videoPlayerRef.$el.querySelector('video');
                this.isPlaying = false;
                //  video.playbackRate = 1;
                //  this.currentVideoSpeed = 1;
            },

            updatePlayerPlayAction(){
                // let video = this.$refs.videoPlayerRef.$el.querySelector('video');
                this.isPlaying =  true;
                // video.playbackRate = 1;
                // this.currentVideoSpeed = 1;
            },

            playPauseToggle(){
                console.log('this....',this);
                let video = this.$refs.videoPlayerRef.$el.querySelector('video');
                if(video.paused){
                    video.play();
                    this.isPlaying = true;
                    // video.playbackRate = 1;
                    // this.currentVideoSpeed = 1;
                }else{
                    video.pause();
                    this.isPlaying = false;
                    // video.playbackRate = 1;
                    // this.currentVideoSpeed = 1;
                }

                try{
                    window.blur();
                }catch(e){console.log(e)}
            },

            forwardBackwardVideoBy1Sec(action) {
                if (!action) {
                    console.log("Invalid action");
                    return false;
                }
                let video = this.$refs.videoPlayerRef.$el.querySelector('video');
                if (video) {
                    let dur = video.duration; //full duration of video
                    let curDur = video.currentTime; //current time of a video
                    if (dur != undefined && curDur != undefined) {
                        //forward 1 second
                        if (action == "forward" && curDur < (dur + 1)) {
                            video.currentTime = curDur + 1
                        }
            
                        //backward 1 second
                        if (action == "backward" && curDur > 1) {
                        video.currentTime = curDur - 1
                        }
                    }
                }
            
            },

            forwardBackwardVideoByFrame(type){
                if (!type) {
                    console.log("Invalid type");
                    return false;
                }
                let video = this.$refs.videoPlayerRef.$el.querySelector('video');
                if (video) {
                    let dur = video.duration; //full duration of video
                    let curDur = video.currentTime; //current time of a video
                    if(type == "forward"  && curDur == 0){
                        video.currentTime = (curDur + 0.04 + 0.001);
                        return;
                    } 
                    if (dur != undefined && curDur != undefined) {
                        //forward 1 second
                        if (type == "forward" && curDur < (dur + 0.04)) {
                            video.currentTime = (curDur + 0.04)
                            Utils.getExactDuationInSeconds(curDur + 0.04);
                        }

                        //backward 1 second
                        if (type == "backward" && curDur > 0.04) {
                            video.currentTime =(curDur - 0.04)
                            Utils.getExactDuationInSeconds(curDur - 0.04);
                        }
                    }
                }
            },
            captureFrame(extractFramesInVideo=false){
                console.log("extractFramesInVideo",extractFramesInVideo)
              if(this.fileInfo && this.fileInfo.proxy_info && 'video_hires_uri' in this.fileInfo.proxy_info && this.fileInfo.proxy_info.video_hires_uri){
                let video = this.$refs.videoPlayerRef.$el.querySelector('video');
                
                if (video) {
                    if(! video.paused){
                        this.playPauseToggle()
                    }
                    //let inVal = parseInt((video.currentTime + 0.001) * 1000); // 1000 = 1millisecond
                    let inVal = Utils.getBoundingOrNearestFrame(video.currentTime * 1000); // 1000 = 1millisecond
                    // let fileDurInMilliSec = this.fileInfo.duration*1000
                    // if(extractFramesInVideo){
                    //     //generating frames for vry 500 milliSec
                    //     for(let eachMilli=0;eachMilli<=fileDurInMilliSec;eachMilli=eachMilli+500){
                    //         let payload = {
                    //             media_in: eachMilli,
                    //             file_uid: this.fileInfo.file_uid,
                    //             crop:[],
                    //             extract_frames:extractFramesInVideo,
                    //             job_name: "Extract Frame",
                    //             element_type: "file",
                    //             personality_id:this.parentActivePersonalityId,
                    //             dst_file_name:this.fileInfo.slug_name?(this.fileInfo.slug_name+'_'+eachMilli):(this.fileInfo.file_name+'_'+eachMilli),
                    //         }
                    //         if(Object.keys(this.selectedServiceDetails).length){
                    //             payload["ai_registry_id"] = this.selectedServiceDetails.registry_id;
                    //         }
                    //         this.createNewJob(payload)
                    //     }
                    //     this.$toast.success("Job submitted successfully")
                    //     return
                    // }
                   
                    let payload = {
                        media_in: inVal,
                        file_uid: this.fileInfo.file_uid,
                        version_id: this.fileInfo.version_id,
                        crop:[],
                        extract_frames:extractFramesInVideo,
                        job_name: "Extract FD Frame",
                        element_type: "file",
                        personality_id:this.parentActivePersonalityId,
                        dst_file_name:this.fileInfo.slug_name?(this.fileInfo.slug_name+'_'+inVal):(this.fileInfo.file_name+'_'+inVal),
                    }
                    if(Object.keys(this.selectedServiceDetails).length){
                        payload["ai_registry_id"] = this.selectedServiceDetails.registry_id;
                    }
                    this.createNewJob(payload).then(data=>{
                        if(Utils.isAcceptedStatusCode(data.statusCode)){
                            this.$toast.success("Job submitted successfully")
                        }else{
                            this.$toast.error(data.message)
                        }
                    })
                    if(!this.faceDetectContext || (this.faceDetectContext && this.faceDetectContext.trim().length <= 0)){
                        this.$nextTick(() => {
                            if(this.$refs.facesWindow){
                                this.$refs.facesWindow.scrollTop = 0;
                            }
                        });
                    }
                }
              }else{
                alert('High resolution proxy is missing for this file. Hence skipping the frame extraction.')
              }
            },
            updateFastwardValue(speedAction){
                var video = this.$refs.videoPlayerRef.$el.querySelector('video');
                if(speedAction == 'forward'){
                if(this.currentVideoSpeed >=1){
                    if(this.currentVideoSpeed >=5){
                    this.currentVideoSpeed = 1;
                    }else if(this.currentVideoSpeed < 5){  
                    this.currentVideoSpeed ++;
                    }  
                }  
                }else{
                if(this.currentVideoSpeed>1 && this.currentVideoSpeed <= 5)this.currentVideoSpeed --;
                }
                // this.currentVideoSpeed = speed;
                video.playbackRate = parseInt(this.currentVideoSpeed);
            
            },
            
            updateBackwardValue(){
                var video = this.$refs.videoPlayerRef.$el.querySelector('video');
                if(this.currentVideoSpeed>1 && this.currentVideoSpeed <= 5){
                    this.currentVideoSpeed --;
                    video.playbackRate = parseInt(this.currentVideoSpeed);
                }   
            },

            resetVideoSpped(){
                let video = this.$refs.videoPlayerRef.$el.querySelector('video');
                video.playbackRate = 1;
                this.currentVideoSpeed = 1;
            },

            replaceByDefaultImage(e){
                if(this.isImageFile()){
                    e.target.onerror = null
                    e.target.src = Utils.getNoThumbnailImg();
                    // this.isImageLoadedForFaceDetection = false;
                }    
            },

            getThumbnailPath(file){
                //Highres is mandatory for AI Face detection
                return Utils.getThumbnailPathfromFileInfo(file, true);
            },
            getLowresPath(file){
                return Utils.getLowresPathfromFileInfo(file)
            },

            closeModel(){
                if(this.faceDetectContext == "fromPersonalityContext"){
                    this.$emit("closeFaceModel", true);
                }else{
                    this.$router.go(-1);
                }
                // this.isImageLoadedForFaceDetection= false;
            },

            getPersonlities(keyword){
                let payload = {};
                if(keyword){ 
                    // payload["param"] = {"name":keyword}
                    payload["name"] = keyword;
                }
                this.getPersonalitiesListByServer(payload).then((data)=>{
                    this.personalitiesList = data.personalities;
                    if(keyword){
                        let indx = data.personalities.findIndex((obj)=>obj.display_name.toLowerCase() == keyword.toLowerCase()); 
                        if(indx < 0){
                            this.personalitiesList.unshift({"display_name":`"${keyword}" (+ create new)`, "_id":"0001"});
                        }    
                    }else{
                        this.personalitiesList.unshift({"display_name":"(+ Create new)", "_id":"0001"});
                    }
                });
            },

            getFacesDataFromServer(){
                let payload = {};
                payload["versionId"] = this.fileInfo.version_id;
                payload.params = {};
                this.getServerfaceDetectionData(payload).then((data) => {
                    if(data.object && 'objects_info' in data.object){
                        if(this.fileInfo.mime_type && this.fileInfo.mime_type.startsWith('video/')){
                            this.faceObjectList = data.object.objects_info.sort((a, b) => a.media_in - b.media_in);
                        }else{
                            this.faceObjectList = data.object.objects_info
                        }
                        if('entry_exists' in data.object){
                            this.isNewEntry = !data.object['entry_exists']
                        }else{
                            this.isNewEntry = false;
                        }
                    }
                    if('personality_info' in data){
                        this.personalityInfoObj = data.personality_info;
                    }

                    for(let i=0; i<this.faceObjectList.length;i++){
                        if(this.faceObjectList[i].status == 'suggested'){
                            this.isSuggestionExists = true;
                            break;
                        }
                    }
                })
            },
            handlePersonalityUpdateNotification(notification){
                notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
                if(notification.message){
                    let person_info = notification.message
                        if([NotifierConstants.personalityCreateNotification].includes(notification.message_type)){
                            let newProfle = {name:person_info.name, profile_image:person_info.profile_image,_id:person_info._id}
                            this.personalityInfoObj.push(newProfle)
                        }else if([NotifierConstants.personalityUpdateNotification].includes(notification.message_type)){
                            let indx = this.personalityInfoObj.findIndex(op=>op._id == person_info._id)
                            if(indx >= 0){
                                if('name' in person_info){
                                    this.$set(this.personalityInfoObj[indx],"name",person_info.name);
                                }
                                if('alias' in person_info){
                                    this.$set(this.personalityInfoObj[indx],"alias",person_info.alias);
                                }
                            if(person_info.profile_image && person_info.profile_image.trim().length > 0){
                                this.$set(this.personalityInfoObj[indx],"profile_image",person_info.profile_image)
                            }
                            }
                        }else if([NotifierConstants.personalityDeleteNotification].includes(notification.message_type)){
                            this.personalityInfoObj = this.personalityInfoObj.filter(op=>op._id != person_info._id)
                        }
                }
            },
            handleFDUpdateNotification(notification){
                notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
                if(notification.message){
                    let fd_info = notification.message
                        if([NotifierConstants.faceDetectionCreateNotification, NotifierConstants.faceDetectionUpdateNotification].includes(notification.message_type)){
                            if((fd_info.version_id == this.fileInfo.version_id) || ('parent_version_id' in fd_info && fd_info.parent_version_id == this.fileInfo.version_id)){
                                if(this.fileInfo.mime_type && this.fileInfo.mime_type.startsWith('video/')){
                                    this.getFacesDataFromServer();
                                    return;
                                }
                                this.faceObjectList = fd_info.objects_info;
                                if('personality_info' in fd_info){
                                    // Check and add entries from array fd_info to personalityInfoObj if not already present
                                    fd_info['personality_info'].forEach(entry => {
                                        // Check if entry already exists in personalityInfoObj
                                        var exists = this.personalityInfoObj.some(info => info._id === entry._id);
                                        if (!exists) {
                                            // If not exists, add it to personalityInfoObj
                                            this.personalityInfoObj.push(entry);
                                        }
                                    });
                                }
                            }
                            this.$forceUpdate();
                        }
                }
            },
            loadFaceDetectionServices(){
                this.getRegisteredFaceRecServices().then((data) =>{
                    this.serviceOptionList = data.services;

                    if(localStorage.getItem('face-detection-service') != null){
                        let old = JSON.parse(localStorage.getItem('face-detection-service'));
                        if(old){
                            let found = this.serviceOptionList.find((el) => el._id == old._id);
                            if(found){
                                this.selectedServiceDetails = found;
                            }
                        }
                    }
                        else{
                        if(this.serviceOptionList.length){
                            this.selectedServiceDetails = this.serviceOptionList[0];
                        }
                    }
                });
            },
            saveService(option){
                if(option)
                    localStorage.setItem('face-detection-service',JSON.stringify(option));
            },

            openTagFacesWindow(failedJob = null){
                let video = this.$refs.videoPlayerRef.$el.querySelector('video');
                if (video && ! video.paused){
                    this.playPauseToggle()
                }
                this.tagForFailedJobs = failedJob
                this.isCapturedFaceTag=true;
            },
            
            handleFDConfigNotification(notification){
                notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
                if(notification.message){
                    let fd_config = notification.message
                    if('vision' in fd_config){
                        this.visionConfig = fd_config.vision
                        if(!('enable_fd_for_video' in this.visionConfig)){
                            this.visionConfig['enable_fd_for_video'] = false
                        }
                    }
                }
            },
            async handleJobNotification(notification){
                notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
                if(notification.message){
                    let jobInfo = Object.assign({}, notification.message);
                    if(!["Extract FD Frame","Face Detection"].includes(jobInfo.job_name)){
                        return
                    }
                    let jobFileUid = jobInfo.file_uid
                    if(!jobFileUid || ('data' in jobInfo && 'file_uid' in jobInfo.data)){
                        jobFileUid = jobInfo.data.file_uid
                    }
                        if(jobFileUid == this.fileInfo.file_uid && jobInfo.job_name == "Extract FD Frame" && 'user_id' in jobInfo){
                            jobInfo["state"] = "QUEUED"
                            jobInfo['sub_job_name'] = "preprocessing"
                            if(jobInfo.state == 'COMPLETED'){
                                jobInfo['sub_job_name'] = "preprocessed"
                            }
                            if('error_message' in jobInfo && jobInfo.error_message.trim().length > 0){
                                jobInfo['state'] = "FAILED";

                            }
                            let jobIndx = this.frameJobs.findIndex(op=>op.job_id == jobInfo.job_id)
                            if(jobIndx >= 0 ){
                                if('dst_file_uid' in jobInfo){
                                    let rInx = this.relativeFDFileUids.findIndex(o=>o.file_uid == jobInfo.dst_file_uid)
                                    if(rInx < 0){
                                        this.relativeFDFileUids.push({'file_uid':jobInfo.dst_file_uid, 'parent_job_id':jobInfo.job_id})
                                    }
                                }
                                this.frameJobs[jobIndx] = jobInfo
                                this.$forceUpdate();
                                // if(jobInfo['state'] == "FAILED"){
                                //     setTimeout(() => {
                                //         this.frameJobs.splice(jobIndx,1)
                                //     },100)
                                // }
                            }else if(jobInfo.user_id == this.getLoggedInUserId){
                                //adding new job entry
                                this.frameJobs.unshift(jobInfo)
                                if('dst_file_uid' in jobInfo){
                                    this.relativeFDFileUids.push({'file_uid':jobInfo.dst_file_uid, 'parent_job_id':jobInfo.job_id})
                                }
                            }
                        }
                        else if(jobInfo.job_name == "Face Detection"){
                            let relativeExFD = this.relativeFDFileUids.find(op=>op.file_uid == jobFileUid)
                            if(relativeExFD){
                                let fdJobIndx = this.frameJobs.findIndex(op=>op.job_id == relativeExFD.parent_job_id)
                                if(fdJobIndx >= 0 ){
                                    let jDetails = this.frameJobs[fdJobIndx];
                                    if(this.fileInfo.mime_type.startsWith('video/')){
                                    jDetails['sub_job_name'] = "preprocessed";
                                    jDetails['status_info'] = {"progress":50};
                                    if(jobInfo.status_info && jobInfo.status_info.progress && jobInfo.status_info.progress > 50){
                                        jDetails["status_info"] = jobInfo.status_info;
                                    }
                                    }else{
                                        if(jobInfo.status_info && 'progress' in jobInfo.status_info){
                                            jDetails['status_info'] = jobInfo.status_info;
                                        }else{
                                            jDetails['status_info'] = {"progress":0};
                                        }
                                    }
                                    jDetails["state"] = "IN_PROGRESS"
                                    jDetails['frame_timecode'] = jobInfo['frame_timecode']
                                    let errMsg = "Failed to Detect Faces."
                                    if(jobInfo.state == "COMPLETED"){
                                        jDetails["state"] = jobInfo.state;
                                        if('version_id' in jobInfo){
                                            let payload = {};
                                            payload["versionId"] = jobInfo['version_id'];
                                            payload.params = {};
                                            let data = await this.getServerfaceDetectionData(payload)
                                            if(data.object && 'objects_info' in data.object && data.object.objects_info && data.object.objects_info.length > 0){
                                                let anyValidObj = data.object.objects_info.filter(op=>['confirmed', 'suggested'].includes(op.status))
                                                if(anyValidObj && anyValidObj.length > 0){
                                                    setTimeout(() => {
                                                        this.frameJobs.splice(fdJobIndx,1)
                                                    },100)
                                                }else{
                                                    jDetails["force_fail"]=true;
                                                    jDetails["state"]= "FAILED";
                                                    jDetails['error_message'] = "Failed to Recognize Face."
                                                }
                                            }else{
                                                jDetails["force_fail"]=true;
                                                jDetails["state"]= "FAILED";
                                                jDetails['error_message'] = errMsg;
                                            }
                                        }else{
                                            jDetails["force_fail"]=true;
                                            jDetails["state"]= "FAILED";
                                            jDetails['error_message'] = errMsg;
                                        }                                        
                                    }else if(('error_message' in jobInfo && jobInfo.error_message.trim().length > 0) || jobInfo.state == "FAILED"){
                                        jDetails['state'] = "FAILED";
                                        jDetails['error_message'] = errMsg;
                                        jDetails["force_fail"]=true;
                                        // setTimeout(() => {
                                        //     this.frameJobs.splice(fdJobIndx,1)
                                        // },100)
                                    }
                                    this.frameJobs[fdJobIndx] = jDetails;
                                    this.$forceUpdate();
                                }
                            }
                        }
                }
            },
            reloadThePage(){
                this.getFaceDetectionConfigData();
                this.loadFaceDetectionServices();
                this.getFacesDataFromServer();
                this.getPersonlities();
                this.$toast.info("Refreshed!")
            },
            handleCustomProxyNotification(notification){
                notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
                if(notification.message){
                    let message = notification.message
                    if(message.proxy_info && this.fileInfo.file_uid == message.file_uid){
                        if('hires_thumbnail' in message.proxy_info && message.proxy_info.hires_thumbnail){
                            this.$set(this.fileInfo['proxy_info'], 'hires_thumbnail', Utils.convertToLoginIPDomainName(message.proxy_info.hires_thumbnail))
                        }
                        if('video_hires_uri' in message.proxy_info && message.proxy_info.video_hires_uri){
                            this.$set(this.fileInfo['proxy_info'], 'video_hires_uri', message.proxy_info.video_hires_uri)
                        }
                        if((!('lowres_uri' in this.fileInfo.proxy_info) || !this.fileInfo.proxy_info.lowres_uri) && 'lowres_uri' in message.proxy_info && message.proxy_info.lowres_uri){
                            this.$set(this.fileInfo['proxy_info'], 'lowres_uri', message.proxy_info.lowres_uri)
                            if(this.$refs.videoPlayerRef){
                                this.$refs.videoPlayerRef.restartPlayer(message.proxy_info.lowres_uri)
                                this.playerListener()
                            }
                        }
                    }
                }
            },
            registerforWebsocketNotifications(){
                // this.addWSEventListener({eventname:[NotifierConstants.assetModifiedNotification],callback:this.handleProxyUpdateNotification,parent:"faceDetection"})
                // this.addWSEventListener({eventname:[NotifierConstants.faceFrameCreateNotification, NotifierConstants.faceFrameExtractedNotification],callback:this.handleFDFrameCreateNotification,parent: "faceDetection"})
                this.addWSEventListener({eventname:[NotifierConstants.faceDetectionCreateNotification,NotifierConstants.faceDetectionUpdateNotification],callback:this.handleFDUpdateNotification,parent: "faceDetection"});
                this.addWSEventListener({eventname:[NotifierConstants.personalityCreateNotification,NotifierConstants.personalityUpdateNotification,NotifierConstants.personalityDeleteNotification],callback:this.handlePersonalityUpdateNotification,parent: "faceDetection"})
                this.addWSEventListener({eventname:[NotifierConstants.faceDetectionConfigUpdated],callback:this.handleFDConfigNotification,parent: "faceDetection"});
                this.addWSEventListener({eventname:["JOB_STATUS_UPDATE"],callback:this.handleJobNotification,parent: "faceDetection"});
                this.addWSEventListener({eventname:[NotifierConstants.customProxyGeneratedNotification],callback:this.handleCustomProxyNotification,parent: "faceDetection"});
            },
            UnregisterfromWebsocketNotifications(){
                // this.removeWSEventListener({eventname:[NotifierConstants.assetModifiedNotification],callback:this.handleProxyUpdateNotification,parent:"faceDetection"})
                // this.removeWSEventListener({eventname:[NotifierConstants.faceFrameCreateNotification, NotifierConstants.faceFrameExtractedNotification],callback:this.handleFDFrameCreateNotification,parent: "faceDetection"})
                this.removeWSEventListener({ eventname:[NotifierConstants.faceDetectionCreateNotification,NotifierConstants.faceDetectionUpdateNotification],callback:this.handleFDUpdateNotification,parent: "faceDetection"});
                this.removeWSEventListener({eventname:[NotifierConstants.personalityCreateNotification,NotifierConstants.personalityUpdateNotification,NotifierConstants.personalityDeleteNotification],callback:this.handlePersonalityUpdateNotification,parent: "faceDetection"})
                this.removeWSEventListener({eventname:[NotifierConstants.faceDetectionConfigUpdated],callback:this.handleFDConfigNotification,parent: "faceDetection"});
                this.removeWSEventListener({eventname:["JOB_STATUS_UPDATE"],callback:this.handleJobNotification,parent: "faceDetection"});
                this.removeWSEventListener({eventname:[NotifierConstants.customProxyGeneratedNotification],callback:this.handleCustomProxyNotification,parent: "faceDetection"});
            },
            getFaceDetectionConfigData(){
                let payload = {};
                this.getFaceDetectionConfigDataFromServer(payload).then((data)=>{
                    this.visionConfig = data.vision
                    if(!('enable_fd_for_video' in this.visionConfig)){
                        this.visionConfig['enable_fd_for_video'] = false
                    }
                });
            },
            ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
            ...mapActions("jobs",["createNewJob"]),
            ...mapActions("assets", ["getAssetInfoFromServer"]),
            ...mapActions("faceDetection", ["addNewFaceDetectionEntry","getServerfaceDetectionData", "getPersonalitiesListByServer", "updatePersonlaityWithFace", "addNewPersonalityFromServer","getRegisteredFaceRecServices", "fetchFacesFromSubclip"]),
            ...mapActions("AIDataSet", ["getFaceDetectionConfigDataFromServer"]),
        },

        async created(){
            if(this.parentActivePersonalityId){
                this.activePersonalityId = this.parentActivePersonalityId
            }
            this.getFaceDetectionConfigData();
            this.loadFaceDetectionServices();
            this.fileInfo = this.filesInfo[0];
            this.loadedImagePath = this.getThumbnailPath(this.fileInfo);
            Object.assign(this.parentRouteInfo, this.$route.params.parentinfo?this.$route.params.parentinfo:{})
            Object.assign(this.fileInfo, this.$route.params.fileInfo?this.$route.params.fileInfo:{})

            // this.fileId = this.fileInfo.file_uid
            // if (Object.keys(this.fileInfo).length == 0){
            // let data = await this.getAssetInfoFromServer({params:{assetId:this.$route.params.assetId}})
            // this.assetId = this.$route.params.assetId
            // Object.assign(this.fileInfo, data.asset);
            // this.fileId = this.fileInfo.file_uid
            
            // }
            
            if (this.fileInfo.mime_type.startsWith("video")){
                        this.videoOptions.sources = [{
                            src:this.getLowresPath(this.fileInfo),
                            type: "video/mp4"
                        }];
                    }

            this.isLoaded=false;
            this.getFacesDataFromServer();
            this.getPersonlities();
            // this.refreshFileInfoAndShowAsset(this.fileInfo.file_uid);
            this.registerforWebsocketNotifications();
        },
        beforeDestroy(){
            if(this.controller.player)this.controller.player.off('pause', this.regionPlayedHandler);
            this.UnregisterfromWebsocketNotifications();
            // window.removeEventListener('keydown', this.handleKeydownEventOnFaceDetectionWindow); //commened because tab support should be given for all detected face also, that support is not there so given delete icon for now for manually drawn box
            document.getElementsByClassName("preview-child-wrapper")[0].removeEventListener('click', this.removeSelectedFaceBox);
            if(this.cropper){
               this.cropper.destroy();
            }
        },
        // mounted(){
        //     this.controller.player.$on('regionPlayed', this.regionPlayedHandler);
        // },
        mounted(){
            //  window.addEventListener('keydown', this.handleKeydownEventOnFaceDetectionWindow);
             document.getElementsByClassName("preview-child-wrapper")[0].addEventListener('click', this.removeSelectedFaceBox);
        },
        computed: {
            ...mapGetters("users",["getLoggedInUserId"]),
            currentProperties(){
                if(this.frameJobs){
                    return {"jobsList":this.frameJobs}
                }
                return {}
            },
            filteredObjects() {
                if(this.search != null){
                    if (!this.faceObjectList.length) {
                        return [];
                    }
                    return this.faceObjectList.filter((item) => {
                        const name = item.name.toLowerCase();
                        const searchTerm = this.search.toLowerCase();
                        return name.includes(searchTerm);
                    });
                }else{
                    return this.faceObjectList;
                }
            },
            confirmedInOutObjects(){
                let objects = []
                let filterKey = ""
                if(this.search != null && this.search && this.search.trim().length > 0){
                    filterKey = this.search
                }
                this.faceObjectList.forEach(obj => {
                    let matchingGroup = objects.find(group => group.every(item=>item.mark_in === obj.mark_in &&
                                                                                item.media_out === obj.media_out &&
                                                                                item.status === "confirmed" 
                                                                                ));
                    
                    if(obj.status === "confirmed"){
                        if(obj.display_name.toLowerCase().includes(filterKey.toLowerCase())){
                            if (matchingGroup) {
                                matchingGroup.push(obj);
                            } else {
                                objects.push([obj]);
                            }
                        }    
                    }
                });
                return objects;
            },
            suggestedInOutObjects(){
                let objects = []
                let filterKey = ""
                if(this.search != null && this.search && this.search.trim().length > 0){
                    filterKey = this.search
                }
                this.faceObjectList.forEach(obj => {
                    let matchingGroup = objects.find(group => group.every(item=>item.mark_in === obj.mark_in &&
                                                                                item.media_out === obj.media_out &&
                                                                                item.status === "suggested" 
                                                                        ));
                    
                    if(obj.status === "suggested"){
                        if(obj.display_name.toLowerCase().includes(filterKey.toLowerCase())){
                            if (matchingGroup) {
                                matchingGroup.push(obj);
                            } else {
                                objects.push([obj]);
                            }
                        }    
                    }
                });
                return objects;
            }
        },
    }
</script>


<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $panel-heading-font-size:18px;
    $secondary-border-color: 1px solid #2b2b2b;
    $howManySteps: 100;
    $borderWidth: 5px;
    $animationTime: .001s;
    $border-color-default: #efefef;
    $border-color-fill: #ffb43e;
    $size: 35px;

     .modal-dialog {
        width: 100vw;
        height: 100vh;
        max-width:100%;
        margin: 0;
        padding: 0;
    }

    .modal-content {
        height: auto;
        min-height: 100%;
        border: 0 none;
        border-radius: 0;
        box-shadow: none;
        background: $primary-background !important;
        border: $border-color;
        .modal-body{
        background: $primary-background;
        height:300px;
        padding: 0px 0px 0px 0px;
        display:inline-block;
        width:100%;
        position:relative;
        }
    }

    .add-new-profile-model{
        width:500px;
        height: 200px;
    }

    .modal {
        text-align: center;
        padding: 0!important;
        display:block;
        overflow: hidden;
    }
    .modal:before {
        content: '';
        display: inline-block;
        height: 100%;
        vertical-align: middle;
        margin-inline-end: -4px;
    }
    .modal-dialog {
        display: inline-block;
        text-align: start;
        vertical-align: middle;
    }

    .modal-header,.modal-footer{
        border-bottom: $secondary-border-color  !important;
        border-top: $secondary-border-color  !important;
        background: $secondary-background-color;
        align-items: unset;
        .modal-title{
        // color:$header-color;
        color:#dfdfdf;
        padding:3px;
        }
    }
    .review-title-heading{
        width: 81%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .modal-header .close {
        margin: -1rem -19px -0rem auto !important;
    }

    .modal-footer{
        float: inline-end;
        position: fixed;
        inset-inline-start: -10px;
        bottom: 0;
        width: 100%;
        height: 50px;
        z-index:9;
    }

    .close-icon:hover{
        background: $bg-color-on-hover;
        border-radius: 20px;
    }

    .manual-draw-box.btn-outline-primary svg{
        color:#007bff !important;
    }

    .manual-draw-box.btn-outline-primary:hover{
        svg{
            color:#fff !important;
        }
    }

    .face-detection-main-wrapper{
        .priview-panel{
            width: 68%;
            display: inline-block;
            height: 100%;
            float: inline-start;
            align-items: center;
            justify-content: center;
            border-inline-end: 1px solid #2b2b2b;
            position: relative;
            overflow:auto;
        }
        .face-lists-panel{
            width: 32%;
            display: inline-block;
            height: 100%;
            padding:10px 10px 10px 16px;
        }
    }

    .user-name-or-image{
        height: 36px;
        width: 36px;
        min-width: 36px;
        border: 1px solid #4a4a4a;
        border-radius: 8px;
        text-align: center;
        line-height: 35px;
        text-transform: uppercase;
        margin-top: 6px;
        font-size: 18px;
    }    

    .user-name{
        margin-inline-end:5px;
        position: relative;
        bottom: 7px;
    }

    #palyer_icons_wrapper{
        width: 100%;
        // display: inline-flex;
        // justify-content: center;
        align-items: center;
        height: 50px;
        margin-top: 5px;
        ul{
        display: inline-flex;
        margin-bottom: 0px !important;
        float:inline-start;
        li{
            display: inline-flex;
            height: 40px;
            margin-inline-end: 10px;
            padding: 0px !important;
            width: 45px;
            color: #bcbcbc;;
        }
        }
        .fast-forward-div, .fast-backward-div{
            width: 45px;
            height: 40px;
            display: inline-flex;
            border:1px solid #6c757d;
            color: #bcbcbc;
            justify-content: center;
            align-items: center;
            border-radius: 5px;
            margin-inline-end: 6px;
            svg{
                margin-top:0px;
                width:20px;
                height:20px;
                margin-inline-end: 5px;
                fill: #6c757d;
            }
        }
        .fast-forward-div:hover, .fast-backward-div:hover{
            background-color: #6c757d;
            border-color: #4a4a4a;
            svg{
                fill: #eee;
            }
        }  

        .active-speed{
            border-color: $active-blue;
            color: $active-blue;
        }

        .active-speed:hover{
        color:#eee !important;
        }  

        .reset-btn, .img-capture-btn{
            width: 70px;
            height: 40px;
            display: inline-flex;
            border:1px solid #6c757d;
            color: #b7b7b7;
            justify-content: center;
            align-items: center;
            border-radius: 5px;
            margin-inline-end: 6px;
            float:inline-end;
        }

        .reset-btn:hover, .img-capture-btn:hover{
            background-color: #6c757d;
            border-color: #4a4a4a;
            color:#eee;
        }  
    }

    .comm-project-fields{
        width: 100%;
        // display: inline-flex;
        margin-bottom: 10px;
        display: inline-block;
        // width: 96%;
        justify-content: space-between;
        display: inline-block;
        padding: 9px;
        border-radius: 4px;
        background:$primary-background;
        border: $secondary-border-color !important;
        label{
            margin-bottom: 3px;
            width: 100%;
            text-align: start;
            padding-inline-end: 10px;
            color: $secondary-text-color;
        }
        .input-field-value-div{
            width: 100%;
            display: inline-block;
        }
    }

    .comm-input-field-style{
        background: $primary-background!important;
        float: inline-start;
        padding: $input-field-padding;
        border: $border-color!important;
        font-size:$input-field-and-label-font-size;
        height: $input-field-height;
    }
    .comm-input-label{
        display:inline-block;
        width:100%;
        margin:20px 10px;
        width:80%;
    }

    .primary-btn-style{
        margin-top:1%;
        justify-content: flex-end;
        button{
            height: 35px;
            width: 70px;
        font-size:14px;
        }
    }

    .secondary-btn-style{
        color:$text-color;
    }

    .object-filter-wrapper {
        // inset-inline-end :16px;
        height: 50px;
        position: relative;
        width:60%;
        .search-bar{
            background: $primary-background!important;
            height:40px;
            width: 100% !important;
            float: inline-start;
            margin:0px !important;
            padding: 0px 32px 2px 12px;
            border: $border-color !important;
        }
    }

    .icon-background-on-hover:hover{
        background: #d1d2d31a;
    }

    .icon-background-on-hover{
        height: 35px;
        width: 35px;
        border-radius: 4px;
        margin: 2px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }

    .search-bar-comm-style {
        // margin-top: 5px;
        display: flex;
        height: 46px;
        // margin-inline-end: 5px;
        align-items: center;
        float:inline-end;
        .edit-panel-heading{
            width: 40%;
            display: inline-block;
            float: inline-start;
            text-align: start;
            font-size: 20px;
            padding-inline-start: 10px;
        }
        .search-bar{
            height:40px;
            float: inline-start;
            padding-inline-start: 12px;
            margin: 0px 3% 0px 3%;
            padding-bottom:2px;
            background: #1a1e21 !important;
            height: 40px;
            float: inline-end;
            padding-inline-start: 12px;
            // margin: 0px 3% 0px 0px;
            padding-bottom: 2px;
            border: 1px solid #4a4a4a !important;
            position: absolute;
            width: 100%;
            // inset-inline-start :6px;
            transition: 0.6s;
        }
    }

    .suggested-faces-list-wrapper{
        display: inline-block; 
        width: 100%;
        // margin-top: 10px;
    }

    .confirmed-faces-list-wrapper{
        display: inline-block;
        width:100%;
    }

    .comm-object-label{
        display:inline-block;
        float:inline-start;
        font-size:16px;
        margin:1px;
        padding:4px 0px;
        // border-radius:10px;
        width:99%;
        border-bottom:1px solid #302f2f;
    }
    
    .comm-object-label:last-child{
        border-bottom: 0px !important;
    }

    .comm-object-label-child{
        display:inline-flex;
        border-radius:5px;
        padding:2px;
        margin-inline-end:10px;
        margin-bottom:6px;
        // align-items:center;
        width:100%;
        .comm-object-label-sub-child{
            display: inline-flex;
            padding: 0px 5px;
            border-radius: 5px;
        }
    }
    .comm-object-label-parent{
        display: inline-flex;
        border-radius: 5px;
        align-items: flex-start;
        // border-bottom: 1px solid #302f2f;
        float: inline-start;
        font-size: 16px;
        margin: 1px;
        padding: 4px 0;
        width: 99%;
    }

    .decetected-face-delete-wrapper{
        visibility: hidden;
        display: inline-flex;
        align-items: center;
        margin-inline-start:10px;
        svg.face-close-icon{
            width:26px !important;
            height: 26px !important;
        }
    }

    .comm-object-label-child:hover{
        .decetected-face-delete-wrapper{
            visibility: visible;
        }
    }

    .thumbnail-view-duration-label{
        font-size: 14px;
        background: #01868c;
        padding: 1px 5px;
        justify-content: start;
        display: flex;
        border-radius: 3px;
        color: $text-color!important;
        width:fit-content;
        align-items: center;
    }

    .transcript-timecode-wrapper{
        display: flex;
        align-items: center;
        margin-inline-end:10px;
        min-width:94px;
        margin-top: 9px;
    }

    .manual-drawn-box-remove-icon-sub-div, .detected-face-box-remove-icon-sub-div{
        position: absolute;
        width: 25px;
        height: 25px;
        inset-inline-end: -12px;
        // top: -12px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: #00000078;
        border-radius: 50%;
        .manual-drawn-box-remove-icon{
            width: 50%;
            height: 50%;
            color: #c5c3c3;
        }
        .manual-drawn-box-remove-icon:hover{
            columns: #fff;
        }
    } 
    .detected-face-box-remove-icon-sub-div{
         visibility: hidden;
    }     

    /* width */
    ::-webkit-scrollbar {
        width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $scrollbar-track-background;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $scrollbar-thumb-background;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $scrollbar-thumb-on-hover-background;
    }


    ::v-deep{  

   .cropper-point {
      background-color: rgb(215, 215, 215); /* Change to desired color, e.g., green */
      border: 3px solid rgb(215, 215, 215); /* Change to desired color, e.g., green */
      width: 7px; /* Adjust size to fit your design */
      height: 7px; /* Adjust size to fit your design */
      box-sizing: border-box; /* Ensure the border is included in the element's dimensions */
    }

        .cropper-view-box {
            box-shadow: 0 0 0 3px rgb(215, 215, 215);
            outline: 0;
        }

        .theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
                background: $primary-background;
                border-bottom: $border-color;
            }
        .theme--light.v-text-field--filled:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot:hover {
            background:$primary-background;
        }
        .theme--light.v-chip {
            border-color:#3a3a3a !important;
            color:$text-color;
        }

        .theme--light.v-chip:not(.v-chip--active) {
            background: $primary-background;
        }

        .v-list-item--link:before{
            background-color:$primary-background;
        }
        .vjs_video_3-dimensions, .video-js{
            height:325px !important;
            width:100% !important;
        }

        #video-player-id{
            .video-js{
                height:100% !important;
                width:100% !important;
            }
            .player-current-time-division{
                width: auto !important;
            }
        }

        .sub-clip-markin-markout-play .video-js .vjs-play-progress {
            background-color: #28cfd8;
        }
        .sub-clip-markin-markout-play .video-js .vjs-play-progress:before {
            font-size: 1.8em!important;
            z-index: 9!important;
            top: -0.43333333333em;
            color: #28cfd8;
        }
        .vjs-sub-clip-marker
        {
            position: absolute;
            background: #ea4863;
            width: 3px;
            height: 18px;
            top: -7px;
            z-index: 30;
            margin-inline-start: -3px;
            border-radius: 3px;
            font-size: 14px;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .sub-clip-markin-markout-play .vjs-control-bar{
            display: flex !important;
            opacity:1 !important;
        }

    .multiselect__content-wrapper{
        display:none;
    }
    .search-bar-comm-style{
        .multiselect__single{
            position: relative;
            inset-inline-start: 14px;
            color:$text-color;
        }
    }
    .multiselect__tag {
        background-color: $primary-background !important;
        }
        .multiselect__option--highlight {
            background: $bg-color-on-hover !important;
        }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
            box-shadow:none !important;
        }
        .multiselect__tag-icon{
        color:$text-color !important;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color: $text-color !important;
        }
        .multiselect__tag-icon:after{
        color:$secondary-text-color!important;
        font-size: 23px;
        }
        .multiselect *{
            font-size: 14px !important;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect{
        color:$text-color !important;
        font-size: $input-field-and-label-font-size !important;
        width:100%;
        }
        .multiselect__option--selected{
        background: $bg-color-on-hover !important;
        color: $text-color;
        }
        .multiselect__content-wrapper{
            border: 1px solid $bg-color-on-hover !important;
            position: absolute;
            display: block;
            background: $text-color;
            width: 100%;
            max-height: 240px;
            overflow: auto;
            border: 1px solid $text-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }
        .multiselect__select,.multiselect__current,.multiselect__option{
            line-height: 12px !important;
        }
        .multiselect--above .multiselect__content-wrapper{
        background:$secondary-background-color !important;
        }
        .multiselect__tags {
            // background: #0000009c !important;
            height: 38px;
            min-height: 38px ;
            margin: 3px 0px 3px 0px ;
            // border: none ;
            border: 1px solid #4a4a4a !important;
            //padding: 8px 40px 0px 8px !important;
            color: #000 !important;
        }
        // .multiselect__select{
        //     inset-inline-end :3px !important;
        //     top: 3px !important;
        // }

        .service-dropdown {
            .multiselect__tags{
                background: transparent !important;
            }
        }

        .personality-dropdown-wrapper .multiselect__tags, .manual-face-box-personality-dropdown .multiselect__tags {
            background: #0000009c !important;
        }  
        
        .personality-dropdown-wrapper .multiselect__content, .manual-face-box-personality-dropdown .multiselect__content{
            width:100% !important;
            .multiselect__option {
                white-space: normal !important;
                line-height:20px !important;
            }
        }

    }

    .personality-dropdown-wrapper{
        display: none;
    }

    .upload-progress-bar{
        // max-height: 190px;
        width: 100%;
        // padding-top: 7px;
        // overflow:auto;
        display: inline-block;
        min-height: 40px;
        align-items: center;
        margin-bottom:15px;
        .edit-upload-info{
            width:7%;
            display: inline-flex;
            justify-content: center;
            // align-items: center;
            padding: 5px;
                svg{
                    position: relative;
                    inset-inline-end: 6px;
                }
        }
        .file-name-with-progress-bar-wrapper{
            display: inline-flex;
            width: 83%;
            align-items: center;
            .file-name-wrapper{
                width: 99%;
                display: inline-block;
                .file-name-display{
                    text-align: start;
                    /* white-space: nowrap; */
                    overflow-wrap: break-word;
                    width: 100%;
                    /* overflow: hidden; */
                    /* text-overflow: ellipsis;*/
                    span{
                        font-size: 14px;
                        color: #dbdbdb;
                    }
                }
                .upload-status-text{
                    text-align: start;
                    float:inline-start;
                    font-size:11px;
                    margin-inline-start:8px;
                    color:#8d8d8d;
                }
                .progress-bar-wrapper{
                    display: inline-flex;
                    width: 100%;
                    .progress-percentage-display{
                        font-size: 11px;
                    }
                    .progress{
                        width: 67%;
                        background: #292929;
                        margin-inline-start: 4px;
                        height: 10px;
                        margin-top: 2px;
                        border-radius: 3px;
                    }
                    .progress-speed-display{
                        font-size: 11px;
                        margin-inline-start: 3px;
                    }
                }
            }
        }
        .file-upload-status-display-wrapper{
            width:10%;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            .file-upload-status{
                height: 100%;
                display: inline-flex;
                width: 100%;
                align-items: center;
                justify-content: center;
            }
        }
    }
.progress {
  width: $size;
  height: $size;
  line-height: $size;
  background: none;
  box-shadow: none;
  position: relative;
  border-radius: 30px !important;
  border: 0px solid #202729;
  &:after {
    content: "";
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: $borderWidth solid #202729;
    position: absolute;
    top: 0;
    inset-inline-start: 0;
  }
  > span {
    width: 50%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 0;
    z-index: 1;
  }
  .progress-left {
    inset-inline-start: 0;
  }
  .progress-bar {
    width: 100%;
    height: 100%;
    background: none;
    border-width: $borderWidth;
    border-style: solid;
    position: absolute;
    top: 0;
    border-color: #009abd;
  }
  .progress-left .progress-bar {
    inset-inline-start: 100%;
    border-top-right-radius: ($size/2);;
    border-bottom-right-radius: ($size/2);;
    border-inline-start: 0;
    -webkit-transform-origin: center left;
    transform-origin: center left;
    //animation: loading-2 1.5s linear forwards 1.8s;
  }
  .progress-right {
    inset-inline-end: 0;
    .progress-bar {
      inset-inline-start: -100%;
      border-top-left-radius: ($size/2);;
      border-bottom-left-radius: ($size/2);;
      border-inline-end: 0;
      -webkit-transform-origin: center right;
      transform-origin: center right;
      //animation: loading-1 1.8s linear forwards;
    }
  }
  .progress-value {
    display: flex;
    border-radius: 50%;
    font-size: 10px;
    text-align: center;
    line-height: 20px;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    font-weight: 300;
    div {
      //margin-top: 10px;
    }
    span {
      font-size: 12px;
      text-transform: uppercase;
    }
  }
}

@for $i from 1 through $howManySteps {
	$stepName: ($i*(100 / $howManySteps));

	//animation only the left side if below 50%
	@if $i <= ($howManySteps/2) { 
		.progress[data-percentage="#{$stepName}"] {
			.progress-right .progress-bar {
				animation: loading-#{$i} $animationTime linear forwards;
			}
			.progress-left .progress-bar {animation: 0;}
		}
	}
	//animation only the right side if above 50%
	@if $i > ($howManySteps/2)  {  
		.progress[data-percentage="#{$stepName}"] {
			.progress-right .progress-bar {
				animation: loading-#{($howManySteps/2)} $animationTime linear forwards; //set the animation to longest animation
			}
			.progress-left .progress-bar {
      animation: loading-#{$i - ($howManySteps/2)} $animationTime linear forwards $animationTime;
    }
		}
	}
}

//animation
@for $i from 1 through ($howManySteps/2) { 
	$degrees: (180/($howManySteps/2));
	$degrees: ($degrees*$i);
	@keyframes loading-#{$i}{
    0%{
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100%{
        -webkit-transform: rotate($degrees);
			transform: rotate(#{$degrees}deg);
    }
	}
}
</style>    
